export const workspace = {
codeLanguagesLabel: "Langage du code",
codeLanguages: {
curl: "curl",
js: "JavaScript",
python: "Python",
powerQuery: "Power Query",
powershell: "PowerShell",
},
overviewScreen: {
loading: "Chargement de l’espace de travail…",
fallbackWorkspaceName: "Espace de travail",
fallbackTeamName: "Équipe",
fallbackPersonalName: "Personnel",
notSet: "Non défini",
roleUnavailable: "Rôle indisponible",
personalMode: "Mode personnel",
addSummaryHint: "Ajoutez un bref résumé dans le profil de l'organisation.",
currentContextLabel: "Contexte actuel",
yourRoleLabel: "Votre rôle",
currencyLabel: "Devise",
languageLabel: "Langue",
manageOrgA11y: "Gérer le profil de l'organisation",
viewOrgA11y: "Afficher le profil de l'organisation",
manageOrgTitle: "Gérer l'organisation",
viewOrgTitle: "Afficher l'organisation",
manageOrgSubtitle: "Profil, informations juridiques et résumé de l'entreprise.",
teamsA11y: "Équipes et invitations",
teamsTitle: "Équipes et invitations",
teamsSubtitle: "Changez de contexte, gérez les adhésions et les invitations.",
configurationTitle: "Configuration",
configurationSubtitle: "Tout ce que vous pouvez configurer, regroupé par domaine.",
groupWorkspaceLabel: "Espace de travail",
groupOperationsLabel: "Opérations",
groupTemplatesLabel: "Check-lists",
groupIntegrationsLabel: "Intégrations",
groupAiLabel: "IA",
groupBillingLabel: "Facturation",
groupSupportLabel: "Assistance",
itemOrgProfileTitle: "Profil de l'organisation",
itemOrgProfileSubtitleAdmin: "Nom légal, secteur d’activité, adresse et notes privées.",
itemOrgProfileSubtitleMember: "Affichez la dénomination sociale, le secteur d'activité et l'adresse.",
itemTeamsTitle: "Équipes et invitations",
itemTeamsSubtitleAdmin: "Membres, rôles, changement de contexte et invitations.",
itemTeamsSubtitleMember: "Afficher les membres et les rôles ; changer de contexte.",
itemBrandingTitle: "Image de marque des rapports",
itemBrandingSubtitleAdmin: "Logo et détails de l'entreprise pour les PDF, les partages et les exportations uniquement.",
itemBrandingSubtitleMember: "Affichez le logo et les détails de l'entreprise utilisés sur les PDF, les partages et les exportations.",
itemContractorWorkTitle: "Mon travail en tant qu'entrepreneur",
itemContractorWorkSubtitle: "Interventions et demandes de devis que d’autres espaces de travail vous ont envoyés.",
itemMaintenancePlansTitle: "Plans de maintenance",
itemMaintenancePlansSubtitle: "Tous les plans récurrents de l’espace de travail, regroupés par actif.",
itemFeaturesTitle: "Fonctionnalités",
itemFeaturesSubtitle: "Ce qui est activé, verrouillé par le forfait ou désactivé.",
itemDefaultsTitle: "Paramètres régionaux par défaut",
itemDefaultsSubtitle: "Devise, langue, fuseau horaire et méthodes de partage.",
itemTemplatesTitle: "Listes de contrôle",
itemTemplatesSubtitle: "Listes de contrôle d’inspection réutilisables.",
itemIndustryPacksTitle: "Packs sectoriels",
itemIndustryPacksSubtitle: "Points de départ pour l'immobilier, la flotte, les équipements et les installations.",
itemIntegrationsTitle: "Intégrations et API",
itemIntegrationsSubtitle: "Imports, API publique, MCP, automatisations et actifs connectés.",
itemAiAuditTitle: "Audit IA et automatisation",
itemAiAuditSubtitle: "Utilisation de l'IA et activité d'automatisation de l'espace de travail.",
itemBillingTitle: "Facturation et utilisation",
itemBillingSubtitleAdmin: "Forfait, crédits IA, actifs facturables et registre des crédits.",
itemBillingSubtitleMember: "Consultez le forfait et l'utilisation des crédits ; seul un administrateur peut les modifier.",
itemHandbookTitle: "Guide d'intégration",
itemHandbookSubtitle: "Guides pour connecter et automatiser AssetWRX.",
},
organizationScreen: {
  allSaved: "Enregistré. Les informations de votre espace de travail sont à jour.",
  allChangesSaved: "Toutes les modifications sont enregistrées",
  saveChanges: "Enregistrer les modifications",
  unsavedKeep: "Continuer",
  unsavedDiscard: "Quitter",
  unsavedBody: "Vous avez modifié des informations sur cette page. Si vous partez maintenant, ces modifications seront perdues.",
  unsavedTitle: "Quitter sans enregistrer ?",
pageTitle: "Profil de l'organisation",
pageSubtitle: "Identité de l’espace de travail, coordonnées et informations juridiques. Le style d’en-tête spécifique au rapport se trouve sous Rapports.",
memberNotice: "Seuls les propriétaires d'espace de travail peuvent modifier les détails de l'organisation et l'image de marque des rapports. Vous pouvez consulter les informations partagées ci-dessous.",
loadingProfile: "Chargement du profil de l'organisation…",
fallbackWorkspaceName: "Espace de travail",
logoSectionTitle: "Logo de l'espace de travail",
changeLogoA11y: "Modifier le logo de l'espace de travail",
uploading: "Téléchargement…",
changeLogo: "Changer le logo",
removeLogoA11y: "Supprimer le logo",
remove: "Supprimer",
workspaceNameLabel: "Nom de l'espace de travail",
workspaceNamePlaceholder: "Libellé de l'espace de travail",
saveWorkspaceName: "Enregistrer le nom de l'espace de travail",
organizationSectionTitle: "Organisation",
summaryLabel: "Résumé",
summaryPlaceholder: "Brève description de votre organisation",
industryLabel: "Secteur d'activité",
companySizeLabel: "Taille de l'entreprise",
companySizePlaceholder: "par ex. 1 à 10, 11 à 50",
websiteLabel: "Site Web",
websitePlaceholder: "https://example.com",
countryCodeLabel: "Code pays",
countryCodePlaceholder: "p. ex. FR",
regionLabel: "Région",
saveOrganization: "Enregistrer l'organisation",
supportContactsTitle: "Contacts d'assistance",
supportEmailLabel: "E-mail d'assistance",
supportPhoneLabel: "Téléphone d'assistance",
saveSupportContacts: "Enregistrer les contacts d'assistance",
legalBillingTitle: "Mentions légales et facturation",
legalBillingSubtitle: "Visible uniquement par les propriétaires de l'espace de travail.",
legalEntityNameLabel: "Nom de la personne morale",
tradingNameLabel: "Nom commercial/affichage",
primaryContactEmailLabel: "Adresse e-mail du contact principal",
primaryContactPhoneLabel: "Téléphone de contact principal",
registeredAddressLabel: "Adresse du siège social",
operationalAddressLabel: "Adresse opérationnelle",
taxNumberLabel: "Numéro fiscal / TVA",
registrationNumberLabel: "Numéro d'immatriculation de la société",
billingContactNameLabel: "Nom du contact de facturation",
billingContactEmailLabel: "E-mail de contact pour la facturation",
billingContactPhoneLabel: "Téléphone de contact pour la facturation",
saveLegalBilling: "Enregistrer les mentions légales et la facturation",
memberPrivateNote: "Les informations relatives à l'entité juridique, aux taxes, à l'enregistrement et à la facturation sont limitées aux propriétaires d'espace de travail.",
reportBrandingLink: "Image de marque des rapports et exportations",
savedTitle: "Enregistré",
workspaceNameSaved: "Nom de l’espace de travail mis à jour.",
saveFailedTitle: "Enregistrement échoué",
couldNotSave: "Impossible d'enregistrer.",
checkPhoneTitle: "Vérifiez le numéro de téléphone",
checkPhoneBody: "Saisissez un numéro valide pour le pays sélectionné, ou laissez le téléphone vide.",
organizationDetailsSaved: "Détails de l'organisation mis à jour.",
legalBillingSaved: "Informations légales et de facturation mises à jour.",
permissionRequiredTitle: "Autorisation requise",
permissionRequiredBody: "Veuillez autoriser l'accès à la photothèque pour télécharger un logo.",
fileTooLargeTitle: "Fichier trop volumineux",
fileTooLargeBody: "Le logo doit faire 10 Mo ou moins.",
logoUpdated: "Logo de l'espace de travail mis à jour.",
uploadFailedTitle: "Échec du téléchargement",
couldNotUploadLogo: "Impossible de télécharger le logo.",
removedTitle: "Supprimé",
logoRemoved: "Logo de l'espace de travail supprimé.",
removeFailedTitle: "Échec de la suppression",
couldNotRemoveLogo: "Impossible de supprimer le logo.",
},
brandingScreen: {
readOnlyTitle: "Lecture seule",
readOnlyBody: "Seuls les propriétaires de l'espace de travail peuvent modifier la personnalisation des rapports.",
permissionRequiredTitle: "Autorisation requise",
permissionRequiredBody: "Veuillez autoriser l'accès à la photothèque pour télécharger un logo.",
fallbackWorkspaceName: "Espace de travail",
workspaceBrandingAppliedTitle: "Personnalisation de l'espace de travail appliquée",
workspaceBrandingAppliedBody: "Le nom et le logo de l'espace de travail ont été copiés dans les champs de personnalisation du rapport. Vérifiez, puis enregistrez pour les appliquer.",
noWorkspaceTitle: "Aucun espace de travail",
noWorkspaceBody: "Votre profil n'a pas encore de compte d'espace de travail.",
savedTitle: "Enregistré",
brandingSaved: "Paramètres de personnalisation du rapport mis à jour.",
saveFailedTitle: "Enregistrement échoué",
couldNotSaveBranding: "Impossible d'enregistrer les paramètres de personnalisation du rapport.",
intro: "Appliqué aux rapports hébergés, aux exportations PDF, aux résultats d'inspection partagés et aux e-mails de partage. Renseignez ces champs pour remplacer la marque AssetWRX par défaut sur ces documents ; laissez-les vides pour conserver les valeurs par défaut d'AssetWRX.",
memberHint: "Seuls les propriétaires d'espace de travail peuvent modifier la personnalisation. Vous pouvez consulter les paramètres actuels ci-dessous.",
fromReportHint: "Cette section a été ouverte à partir de l'espace de travail de reporting. Les modifications s'appliquent immédiatement aux rapports hébergés et aux nouvelles exportations.",
loadingSettings: "Chargement des paramètres de personnalisation…",
reportLogoLabel: "Logo du rapport",
reportLogoHint: "Utilisé uniquement sur les rapports, les exportations PDF et les e-mails de partage.",
changeLogoA11y: "Modifier l'image du logo du rapport",
addLogoA11y: "Ajouter une image de logo de rapport",
changeLogo: "Modifier le logo du rapport",
addLogo: "Ajouter un logo de rapport",
removeLogoA11y: "Supprimer le logo du rapport",
removeLogo: "Supprimer le logo du rapport",
copyFromWorkspaceA11y: "Utilisez le logo et le nom de votre espace de travail pour les rapports",
copyFromWorkspace: "Utiliser le logo et le nom de mon espace de travail",
noLogoHint: "Aucun logo de rapport défini : les exportations utilisent la marque AssetWRX jusqu'à ce que vous en ajoutiez un ici.",
companyNameLabel: "Société / nom d'affichage",
companyNamePlaceholder: "par ex. Services immobiliers Northfield",
companyNameA11y: "Société ou nom d'affichage pour les rapports",
addressBlockLabel: "Bloc d'adresse",
addressBlockPlaceholder: "Lignes d'adresse affichées dans l'en-tête du rapport",
addressBlockA11y: "Bloc d'adresse du rapport",
contactBlockLabel: "Bloc de contact",
contactBlockPlaceholder: "E-mail / téléphone / site Web",
contactBlockA11y: "Bloc de contact du rapport",
footerLabel: "Pied de page / clause de non-responsabilité",
footerPlaceholder: "Clause de non-responsabilité facultative en pied de page du rapport",
footerA11y: "Pied de page ou clause de non-responsabilité du rapport",
accentColorLabel: "Couleur d'accentuation (facultatif)",
accentColorA11y: "Valeur hexadécimale de la couleur d'accentuation du rapport",
accentColorHint: "Utilisez le format hexadécimal (#RRGGBB). Laissez vide pour utiliser l’accent AssetWRX par défaut.",
savingA11y: "Enregistrement de l'image de marque du rapport",
saveA11y: "Enregistrer les paramètres de personnalisation du rapport",
saving: "Enregistrement…",
saveBranding: "Enregistrer l'image de marque",
},
teamsScreen: {
recentlyJoined: "Inscription récente",
switchFailedTitle: "Impossible de changer d'espace de travail",
tryAgain: "Veuillez réessayer.",
pendingInviteTitle: "Invitation d'équipe en attente",
pendingInviteBody_one: "{{count}} invitation en attente dans la gestion d’équipe.",
pendingInviteBody_other: "{{count}} invitations en attente dans la gestion d’équipe.",
teamManagementTitle: "Gestion d'équipe",
teamManagementSubtitle: "Invitations, rôles et options avancées.",
createFirstTeam: "Créez votre première équipe",
openTeamManagement: "Ouvrir la gestion d'équipe",
teamManagementMenuSubtitle: "Paramètres plein écran pour vos équipes et invitations.",
teamsAndContextTitle: "Vos équipes",
teamsAndContextSubtitle: "L'équipe dans laquelle vous travaillez, et toutes les équipes dont vous faites partie.",
changeContext: "Changer d'équipe",
workspaceLabel: "Espace de travail",
currentContextLabel: "Vous travaillez dans",
roleInContextLabel: "Votre rôle",
loadFailed: "Impossible de charger vos équipes. Rouvrez cette page pour réessayer.",
teamMembershipsTitle: "Adhésions aux équipes",
manageInTeamSettings: "Gérer dans les paramètres de l'équipe",
noMemberships: "Vous n’êtes actuellement membre d’aucune équipe.",
membershipMeta: "Rôle : {{role}} · A rejoint {{date}}",
currentBadge: "Actuelle",
workingContextTitle: "Changer d'équipe",
workingContextSubtitle: "Choisissez l'équipe dont vous voyez les actifs et le travail. Personnel n'affiche que les vôtres.",
personalOption: "Personnel",
pendingInviteBody_many: "{{count}} invitations en attente dans la gestion d’équipe.",
},
aiUsageInsights: {
title: "Aperçu de l'utilisation de l'IA",
subtitle: "Regroupe les appels, les crédits et les commentaires des {{days}} derniers jours. Mis à jour lors de l'actualisation.",
refresh: "Actualiser",
loadingUsage: "Chargement de l'utilisation…",
alertHeader_one: "{{count}} fonctionnalité nécessite un examen",
alertHeader_other: "{{count}} fonctionnalités nécessitent un examen",
healthAttention: "Certaines fonctionnalités de l'IA nécessitent une attention particulière : un administrateur d'espace de travail peut examiner les détails.",
healthNormal: "Toutes les fonctionnalités d'IA fonctionnent normalement.",
kpiCreditsBurned: "Crédits consommés",
kpiCalls: "Appels",
kpiErrors: "Erreurs",
kpiCacheHitRate: "Taux de réussite du cache",
projectedMonthly: "Projection mensuelle",
pctOfBudget: "{{pct}} % du budget {{budget}}",
extrapolatedFromWindow: "Extrapolé linéairement à partir de cette période de {{days}} j",
noActivity: "Aucune activité IA dans cette période. Encouragez les utilisateurs à essayer le copilote pour voir des signaux ici.",
colCapability: "Fonctionnalité",
colCalls: "Appels",
colCredits: "Crédits",
colAvgMs: "Ms moy.",
colFeedback: "👍 / 👎",
colAccept: "Accepter",
openDetailHint: "Ouvrir le détail de la fonctionnalité",
alert: {
neverHelpful_one: "{{count}} vote négatif et aucun positif. Signe clair que quelque chose ne va pas.",
neverHelpful_many: "{{count}} votes négatifs et aucun positif. Signe clair que quelque chose ne va pas.",
neverHelpful_other: "{{count}} votes négatifs et aucun positif. Signe clair que quelque chose ne va pas.",
lowAcceptance: "Taux d’acceptation de {{pct}} % (n={{total}}). Revoyez le prompt ou les exemples.",
highErrorRate: "{{pct}} % des appels échouent ({{errors}}/{{calls}}). Vérifiez la fonction edge ou la disponibilité de la check-list.",
},
feature: {
unknown: "Non attribué",
ai_assistant: "Assistant IA",
connected_event: "Événement d’un appareil connecté",
automation: {
asset_health_calculated: "Santé de l’actif calculée",
asset_compliance_calculated: "Conformité de l’actif calculée",
asset_risk_calculated: "Risque de l’actif calculé",
asset_risk_assessment_persist_batch: "Risques des actifs enregistrés en lot",
recipe_run: "Recette d’automatisation exécutée",
},
asset: {
extract_vin_or_serial: "Lire le VIN ou le numéro de série",
generate_advanced_report: "Rapport d’actif avancé",
improve_description: "Améliorer la description de l’actif",
infer_identity: "Identifier l’actif",
journey_summary: "Résumé du parcours de l’actif",
timeline_summary: "Résumé de la chronologie de l’actif",
},
assistant: {
recommend_next_actions: "Prochaines actions de l’assistant",
},
connected: {
event_ingest: "Message d’un appareil connecté",
},
document: {
extract_metadata: "Lire les détails du document",
},
esg: {
  writeup: "Synthèse ESG",
},
home: {
operations_briefing: "Point sur les opérations",
},
insights: {
recommend_next_actions: "Prochaines actions recommandées",
},
inspection: {
analyse_image: "Analyser une photo d’inspection",
completed: "Inspection terminée",
fix_recommendation: "Recommandation de correction",
generate_job_drafts: "Brouillons d’interventions depuis une inspection",
generate_summary: "Résumé d’inspection",
improve_note: "Améliorer une note d’inspection",
},
job: {
completion_closeout: "Clôture de l’intervention",
extract_invoice_line_items: "Lire les lignes de facture",
generate_invoice_draft: "Brouillon de facture",
improve_update_note: "Améliorer une mise à jour d’intervention",
suggest_certificate_draft: "Suggérer un certificat",
suggest_completion_criteria: "Suggérer des critères de fin",
suggest_follow_up_job: "Suggérer une intervention de suivi",
},
quote: {
compare_quotes: "Comparer des devis",
generate_rfq_scope: "Rédiger le périmètre de la demande de devis",
recommend_quote: "Recommander un devis",
summarize_quotes: "Résumer des devis",
},
request: {
polish_follow_up_draft: "Peaufiner la réponse à la demande",
},
site: {
generate_advanced_report: "Rapport de site avancé",
},
template: {
generate_draft: "Brouillon de check-list",
},
vision: {
analyse_group: "Scan WRX Vision",
verify_completion: "Contrôle des justificatifs WRX Verified",
},
work: {
analyse_evidence: "Analyser les justificatifs de travail",
},
},
entityType: {
asset: "Actif",
job: "Intervention",
inspection: "Inspection",
request: "Demande",
quote: "Devis",
site: "Site",
document: "Document",
template: "Check-list",
contact: "Contact",
},
feedback: {
helpful: "Utile",
not_helpful: "Pas utile",
},
action: {
refine: "Affinage demandé",
},
creditMode: {
none: "aucun",
estimated: "estimé",
actual: "réel",
},
alertHeader_many: "{{count}} fonctionnalités nécessitent un examen",
},
aiCapabilityDetail: {
kicker: "Détail des capacités · 30j",
closeA11y: "Fermer le détail",
loading: "Chargement des détails…",
noFeedback: "Aucun retour pour l'instant sur cette fonctionnalité.",
sectionFeedback: "Répartition des commentaires",
sectionActionTaken: "Mesure prise",
sectionDailyActivity: "Activité quotidienne",
noActivity: "Aucune activité sur cette période.",
sectionRecentEntities: "Entités récentes",
totalLine_one: "{{count}} événement au total sur la période.",
totalLine_other: "{{count}} événements au total sur la période.",
totalLine_many: "{{count}} événements au total sur la période.",
},
syncCenter: {
  errors: {
    unsupportedWrite: "Cette modification nécessite une version plus récente de l'application pour être envoyée. Elle reste enregistrée sur cet appareil.",
    waitingOnFailedParent: "En attente de l'élément auquel il appartient, qui n'a pas pu être envoyé. Corrigez ou ignorez d'abord cet élément sur cette page.",
    transientUnknown: "Cette modification n'a pas encore été envoyée. Un nouvel essai aura lieu ; contactez l'assistance si cela se reproduit.",
    permanentUnknown: "Cette modification ne peut pas être appliquée automatiquement. Vérifiez-la ou ignorez-la.",
    serverError: "Le serveur a rencontré un problème. La modification sera renvoyée ; contactez l'assistance si cela se reproduit.",
    rateLimited: "Le serveur est occupé. La modification sera renvoyée sous peu.",
    network: "Problème de connexion. La modification sera envoyée automatiquement, ou vous pouvez réessayer maintenant.",
    conflict: "Une version plus récente est déjà enregistrée. Ignorez cette modification, puis consultez la dernière version.",
    notFound: "L'élément concerné par cette modification a été supprimé. Vous pouvez l'ignorer.",
    permission: "Vous n'avez pas l'autorisation d'envoyer cette modification. Demandez à un administrateur de l'espace de travail.",
    blocked: "Cette modification est enregistrée sur cet appareil mais n'a pas pu être envoyée. Réessayez ou supprimez-la.",
    authRetry: "Reconnectez-vous pour envoyer cette modification. Elle est enregistrée sur cet appareil.",
  },
pageTitle: "Modifications non envoyées",
pageSubtitle: "Les modifications enregistrées sur cet appareil qui attendent d’être envoyées.",
healthTitle: "Santé",
statusSectionTitle: "Statut",
retryAll: "Envoyer maintenant",
queuedWritesSynced: "Tout est envoyé",
lastSync: "Dernier envoi {{age}}",
noSyncsYet: "Rien envoyé pour l’instant",
queuedLabel: "En attente d'envoi",
inFlightLabel: "Envoi en cours",
lastFlushLabel: "Dernier envoi",
lastDurationLabel: "Dernière durée",
never: "Jamais",
pendingWritesTitle: "En attente d'envoi",
unsentAnswersTitle: "Réponses d'inspection sur cet appareil",
unsentAnswersBody: "Elles sont envoyées automatiquement lorsque vous êtes en ligne. Si l'inspection a été modifiée ailleurs, ouvrez-la pour les vérifier et les envoyer.",
openInspection: "Ouvrir l'inspection",
queuedInspectionPhotos: "Photos d'inspection en attente d'envoi : {{total}}",
recoveryNote_one: "Une modification enregistrée par une version antérieure de l'application n'a pas de propriétaire enregistré. Elle a été conservée plutôt qu'attribuée à la personne connectée ensuite. Si ce travail est le vôtre, revendiquez-le et il sera synchronisé ; sinon, ignorez-le.",
recoveryNote_other: "{{count}} modifications enregistrées par une version antérieure de l’application n’ont pas de propriétaire enregistré. Elles ont été conservées plutôt qu’attribuées à la personne connectée ensuite. Si ce travail est le vôtre, revendiquez-le et il sera synchronisé ; sinon, ignorez-le.",
claimAsMine: "Revendiquer comme mien",
discard: "Ignorer",
claimAllAsMine: "Tout revendiquer comme mien",
discardAll: "Tout supprimer",
noQueuedWritesTitle: "Rien en attente d’envoi",
noQueuedWritesBody: "Les modifications faites sur cet appareil sont envoyées dès que vous êtes en ligne. Les photos d’inspection apparaissent sur leur inspection.",
hideTechnicalDetails: "Masquer les détails techniques",
showTechnicalDetails: "Afficher les détails techniques",
technicalDetail_one: "{{rawError}} · {{count}} tentative",
technicalDetail_other: "{{rawError}} · {{count}} tentatives",
retry: "Réessayer",
offlineSupportTitle: "Ce qui fonctionne sans connexion",
statusOnlineRequired: "Nécessite une connexion",
statusLocalDraft: "Enregistré d’abord sur cet appareil",
policyEntity: {
Asset: "Actif",
Inspection: "Inspection",
Job: "Intervention",
Schedule: "Planification",
Request: "Demande",
Comment: "Commentaire",
Media: "Médias",
},
policyAction: {
createAsset: "Créer un actif",
editAsset: "Modifier un actif",
addDocument: "Ajouter un document",
answerChecklistItems: "Répondre aux points de la check-list",
startInspection: "Démarrer une nouvelle inspection",
submitInspection: "Mettre en pause, reprendre ou terminer une inspection",
createJob: "Créer une intervention",
addJobPhotos: "Ajouter des photos en créant une intervention",
postActivity: "Publier des notes d’activité et des photos",
moveJobStatus: "Accepter, planifier ou valider une intervention",
startPauseCompleteJob: "Démarrer, mettre en pause ou terminer une intervention",
updateJobDetails: "Mettre à jour les détails de l’intervention",
scheduleInspection: "Planifier une inspection",
answerCheck: "Répondre à un contrôle",
recordMeterReading: "Relever un compteur",
reportCantComplete: "Signaler que vous ne pouvez pas terminer le travail",
decideChangeRequest: "Statuer sur une demande de modification",
createOrRespondRequest: "Créer ou répondre",
postComment: "Publier un commentaire",
uploadEvidence: "Téléverser des justificatifs",
},
supportCopy: {
queued: "Enregistré sur l’appareil, puis synchronisé automatiquement",
local_draft: "Enregistré sur l’appareil jusqu’à l’envoi",
online_required: "Connexion requise",
},
conflictCopy: {
idempotent_replay: "Nouvelle tentative sans risque : la même opération n’est pas dupliquée.",
merge_review: "Si les données ont changé sur le serveur, vérifiez-les et fusionnez-les avant d’enregistrer.",
latest_write: "La dernière modification acceptée par le serveur fait foi.",
},
entryAsset: "Nouvel actif",
entryInspectionJob: "Intervention d'inspection",
entryJob: "Nouvelle intervention",
entryJobPhoto: "Photo de l'intervention",
entryJobUpdate: "Mise à jour de l'intervention",
entryScheduledInspection: "Inspection planifiée",
entryAssetDocument: "Document de l'actif",
entryFieldMove: "Démarrage, pause ou fin",
entryNewInspection: "Nouvelle inspection",
ageJustNow: "à l'instant",
ageMinutesAgo: "il y a {{mins}} min",
ageHoursAgo: "il y a {{hrs}} h",
ageDaysAgo: "il y a {{days}} j",
readErrorBody: "Le travail enregistré n'a pas pu être lu. Il est toujours sur cet appareil et n'a pas été supprimé.",
flushErrorBody: "Nous n'avons pas pu envoyer vos modifications. Elles sont toujours enregistrées sur cet appareil.",
claimErrorBody: "Ces modifications n'ont pas pu être revendiquées. Elles sont toujours enregistrées sur cet appareil.",
discardManyErrorBody: "Ces modifications n'ont pas pu être ignorées. Elles sont toujours enregistrées sur cet appareil.",
discardOneErrorBody: "La modification n'a pas pu être annulée. Elle reste enregistrée sur cet appareil.",
recoveryNote_many: "{{count}} modifications enregistrées par une version antérieure de l’application n’ont pas de propriétaire enregistré. Elles ont été conservées plutôt qu’attribuées à la personne connectée ensuite. Si ce travail est le vôtre, revendiquez-le et il sera synchronisé ; sinon, ignorez-le.",
technicalDetail_many: "{{rawError}} · {{count}} tentatives",
},
trustCenter: {
pageTitle: "Centre de confiance",
pageSubtitle: "Audit, intégrations, accès et posture de conformité pour cet espace de travail.",
loading: "Chargement...",
auditLogTitle: "Journal d'audit",
auditLogDescription: "Qui a fait quoi, quand, sur les actifs, les interventions, les inspections et les actions d'administration.",
auditLogEmptyTitle: "Journal d'audit pas encore disponible",
auditLogEmptyBody: "Une fois le flux d'audit activé pour votre espace de travail, chaque action significative apparaîtra ici avec l'auteur, la cible et l'horodatage.",
integrationHealthTitle: "État des intégrations",
integrationHealthDescription: "Connecteurs API + MCP + IoT : état de connexion, dernière synchronisation, taux d'erreur.",
integrationHealthEmptyTitle: "Aucune intégration connectée",
integrationHealthEmptyBody: "Connectez une intégration pour voir son état de santé en direct ici — y compris la dernière synchronisation réussie, le taux d'erreur et l'état des nouvelles tentatives.",
webhookRetryTitle: "Nouvelles tentatives du webhook",
webhookRetryDescription: "Livraisons de webhooks sortants qui ont échoué et ont été réessayées, avec des corps et des codes de réponse.",
webhookRetryEmptyTitle: "Aucune défaillance du webhook",
webhookRetryEmptyBody: "Les livraisons de webhook échouées (avec leur historique de tentatives et leur contenu) apparaîtront ici lorsqu'elles se produiront.",
apiKeysTitle: "Clés API et étendues",
apiKeysDescription: "Clés émises, étendues, état de rotation et qui les a créés.",
apiKeysEmptyTitle: "Aucune clé API émise",
apiKeysEmptyBody: "Lorsqu'un propriétaire d'espace de travail crée une clé API, ses étendues et sa cadence de rotation s'affichent ici.",
rolesTitle: "Rôles et autorisations",
rolesDescription: "Qui peut faire quoi au sein des équipes, avec les autorisations effectives et les dérogations.",
rolesEmptyTitle: "Aucune attribution de rôle enregistrée pour le moment",
rolesEmptyBody: "Chaque utilisateur et équipe, les autorisations qu'ils détiennent et toute dérogation apparaîtront ici.",
complianceTitle: "Niveau de conformité",
complianceDescription: "Préparation SOC2 / ISO, résidence des données, conservation et statut d'exportation.",
complianceEmptyTitle: "Aucun signal de conformité enregistré pour le moment",
complianceEmptyBody: "L'état de préparation SOC2/ISO, la résidence des données, la conservation et le statut d'exportation apparaîtront ici au fur et à mesure de leur enregistrement pour cet espace de travail.",
audit: {
byActor: "par {{name}}",
toRecipient: "à {{name}}",
action: {
asset: {
created: "Actif créé",
updated: "Actif mis à jour",
shared: "Actif partagé",
share_revoked: "Partage de l’actif révoqué",
},
inspection: {
created: "Inspection créée",
started: "Inspection commencée",
completed: "Inspection terminée",
failed_item_recorded: "Point non conforme enregistré",
approved: "Inspection approuvée",
reopened: "Inspection rouverte",
shared: "Rapport partagé",
share_approved: "Rapport approuvé",
share_rejected: "Rapport refusé",
},
job: {
created: "Intervention créée",
assigned: "Intervention attribuée",
started: "Intervention commencée",
completed: "Intervention terminée",
reopened: "Intervention rouverte",
verified: "Intervention vérifiée",
},
document: {
created: "Document ajouté",
renewed: "Document renouvelé",
superseded: "Document remplacé",
},
compliance: {
expiring_detected: "Échéance de conformité détectée",
},
insight: {
generated: "Analyse générée",
feedback_submitted: "Avis sur une analyse envoyé",
},
technician: {
assignment_recommended: "Intervenant recommandé",
assignment_accepted: "Affectation acceptée",
},
condition: {
assessment_calculated: "État évalué",
recommendation_created: "Recommandation d’état créée",
recommendation_accepted: "Recommandation d’état acceptée",
recommendation_dismissed: "Recommandation d’état écartée",
},
scheduling: {
recommendation_shown: "Suggestion de planification affichée",
recommendation_selected: "Suggestion de planification choisie",
},
assistant: {
  change: "Modifié via l'assistant",
  undo: "Annulé via l'assistant",
},
},
entity: {
asset: "Actif",
job: "Intervention",
inspection: "Inspection",
document: "Document",
asset_share: "Partage d’actif",
inspection_share: "Partage de rapport",
insight: "Analyse",
compliance: "Conformité",
technician: "Affectation",
site: "Site",
scheduled_inspection: "Inspection planifiée",
template: "Check-list",
asset_request: "Demande",
},
},
},
teamInvite: {
pageTitle: "Invitation d'équipe",
invalidLink: "Lien d'invitation invalide",
loadTimeout: "Le chargement de l'invitation prend trop de temps. Vérifiez votre connexion et réessayez.",
notFound: "Invitation introuvable",
expiredMessage: "Votre invitation{{where}} a expiré{{when}}. Demandez à la personne qui vous a invité d'en envoyer une nouvelle.",
expiredWhereSuffix: " à {{teamName}}",
expiredWhenSuffix: " le {{date}}",
loadFailed: "Échec du chargement de l'invitation",
emailMismatchTitle: "Incohérence des e-mails",
emailMismatchBody: "Cette invitation a été envoyée à {{email}}. Veuillez vous connecter avec cet e-mail pour accepter.",
errorTitle: "Erreur",
linkSendFailedTitle: "Impossible d'envoyer le lien",
linkSendFailedBody: "Veuillez réessayer ou demander à la personne qui vous a invité de renvoyer l'invitation.",
loadingInvitation: "Chargement de l’invitation…",
invalidOrExpiredTitle: "Invalide ou expiré",
linkNoLongerValid: "Ce lien d'invitation n'est plus valide.",
tryAgain: "Réessayer",
goToApp: "Aller à AssetWRX",
cardTitle: "Invitation d’équipe",
invitedPrefix: "Vous avez été invité à rejoindre",
invitedRoleSuffix: "comme {{role}}.",
checkEmailForLink: "Vérifiez {{email}} pour un lien de connexion. Cela vous ramène ici pour accepter.",
signInAsEmail: "Connectez-vous en tant que {{email}} pour accepter cette invitation",
linkSent: "Lien envoyé",
emailSignInLink: "M'envoyer un lien de connexion par e-mail",
signIn: "Se connecter",
wrongAccountHint: "Cette invitation a été envoyée à {{email}}. Connectez-vous avec ce compte.",
signInDifferentAccount: "Se connecter avec un autre compte",
accept: "Accepter",
decline: "Refuser",
},
logoOrInitials: {
logoA11y: "Logo de l'espace de travail",
initialsA11y: "Initiales de l'espace de travail",
},
shellTabsListA11y: "Sections des paramètres de l’espace de travail",
teamManage: {
offerFailedTitle: "Impossible d'envoyer l'offre",
tryAgain: "Réessayez dans un instant.",
offerSent: "{{name}} a été invité(e) à accepter la propriété. Rien ne change tant que la personne n'a pas accepté.",
linkCopied: "Lien d'invitation copié. Envoyez-le comme vous le souhaitez.",
inviteLinkTitle: "Lien d'invitation",
checkEmails: "Vérifiez {{emails}} et réessayez.",
enterEmail: "Saisissez au moins une adresse e-mail.",
invitesSent_one: "Invitation envoyée à {{email}}. La personne recevra un e-mail avec un lien pour rejoindre l'équipe et apparaîtra dans Membres après avoir accepté.",
invitesSent_many: "{{count}} invitations envoyées. Chaque personne reçoit un e-mail avec un lien pour rejoindre l'équipe et apparaît dans Membres après avoir accepté.",
invitesSent_other: "{{count}} invitations envoyées. Chaque personne reçoit un e-mail avec un lien pour rejoindre l'équipe et apparaît dans Membres après avoir accepté.",
undeliveredTitle: "Invitation enregistrée, e-mail non envoyé",
undeliveredBody: "Impossible d'envoyer un e-mail à {{emails}}. Touchez Copier le lien d'invitation et envoyez-le vous-même.",
copyInviteLink: "Copier le lien d'invitation",
ok: "OK",
joined: "Vous avez rejoint {{team}}. Le travail partagé avec l'équipe s'affiche désormais dans Accueil et dans Travail.",
joinFailedTitle: "Impossible de rejoindre l'équipe",
notNow: "Pas maintenant",
declineTitle: "Refuser l'invitation ?",
declineBody: "Refuser l'invitation à {{team}} ? Il vous faudra une nouvelle invitation pour rejoindre l'équipe plus tard.",
declineFailedTitle: "Impossible de refuser l'invitation",
created: "{{name}} est prête. Invitez des personnes pour qu'elles voient ses actifs et son travail.",
createFailedTitle: "Impossible de créer l'équipe",
createFailedBody: "Impossible de créer l'équipe pour le moment. Réessayez dans un instant.",
switchedTo: "Vous travaillez maintenant dans {{team}}",
switchFailedTitle: "Impossible de changer d'équipe",
switchToA11y: "Passer à {{team}}",
personalHint: "Vous êtes en mode Personnel et ne voyez que votre propre travail. Touchez une équipe pour y passer.",
tapToSwitchHint: "Touchez une équipe pour y passer. Les actifs et le travail deviennent ceux de cette équipe.",
noTeamTitle: "Pas encore d'équipe",
noTeamBody: "Créez une équipe pour partager des actifs et du travail avec vos collègues. Vous pourrez ensuite inviter des personnes.",
adoptAssets_one: "Ajouter votre actif à {{team}}. Pour l'instant, vous seul pouvez le voir.",
adoptAssets_many: "Ajouter vos {{count}} actifs à {{team}}. Pour l'instant, vous seul pouvez les voir.",
adoptAssets_other: "Ajouter vos {{count}} actifs à {{team}}. Pour l'instant, vous seul pouvez les voir.",
adoptFailedTitle: "Impossible d'ajouter les actifs",
membershipHint: "Les personnes que vous invitez ici peuvent se connecter et travailler dans cette équipe. Pour garder les coordonnées de quelqu'un sans lui donner accès (un prestataire, un locataire), ajoutez-le dans Contacts.",
emailPlaceholder: "alex@example.com\nsam@example.com",
inviteAsA11y: "Inviter en tant que {{role}}",
roleDescription: {
member: "Réaliser et mettre à jour les interventions, inspections et demandes.",
admin: "Inviter et retirer des personnes, et modifier les paramètres de l'équipe.",
},
sendInvite_one: "Envoyer l'invitation",
sendInvite_many: "Envoyer {{count}} invitations",
sendInvite_other: "Envoyer {{count}} invitations",
inviteExpired: "Expirée le {{date}}. Touchez Renvoyer pour l'inviter à nouveau.",
inviteSentOn: "Envoyée le {{date}}",
resendFailedTitle: "Impossible de renvoyer l'invitation",
resent: "Invitation renvoyée à {{email}}.",
resendA11y: "Renvoyer l'invitation à {{email}}",
cancelInviteA11y: "Annuler l'invitation de {{email}}",
cancelInviteFailedTitle: "Impossible d'annuler l'invitation",
cancelInviteConfirmTitle: "Annuler cette invitation ?",
cancelInviteConfirmBody: "Si {{email}} a déjà le lien, il cessera de fonctionner.",
cancelInviteConfirm: "Annuler l’invitation",
membersTitle: "Membres · {{n}}",
mfaPending: "{{n}} à configurer",
mfaAllCovered: "Tout le monde est protégé",
mfaSocialExempt: "{{n}} se connectent avec Google ou Apple (non requis)",
mfaOnA11y: "{{name}} a activé la double authentification",
mfaOffA11y: "{{name}} n'a pas la double authentification",
moreActionsA11y: "Plus d'actions pour {{name}}",
yourSkills: "Vos compétences",
memberSkills: "Compétences de {{name}}",
skillsSaveFailedTitle: "Impossible d'enregistrer ces compétences",
skillsSaveFailedBody: "Rien n'a été modifié. Vérifiez votre connexion et réessayez.",
saveSkills: "Enregistrer les compétences",
transferBody: "Proposer la propriété de l'équipe à {{name}} ? Cette personne doit accepter avant tout changement ; vous devenez ensuite administrateur.",
sendOffer: "Envoyer l'offre",
resetMfaBody: "Effacer la double authentification de {{name}} ? Il lui sera demandé de configurer à nouveau une application d'authentification à sa prochaine connexion. À utiliser lorsque quelqu'un a perdu son téléphone.",
reset: "Réinitialiser",
resetMfaDoneTitle: "Double authentification réinitialisée",
resetMfaDone: "{{name}} pourra configurer à nouveau la double authentification à sa prochaine connexion.",
resetMfaNothing: "{{name}} n'avait pas de double authentification. Rien à réinitialiser.",
resetFailedTitle: "Impossible de réinitialiser la double authentification",
removeBody: "Retirer {{name}} de l'équipe ?",
removeBodyWithJobs_one: "Retirer {{name}} de l'équipe ? {{count}} intervention en cours lui reste attribuée jusqu'à ce que vous la réattribuiez.",
removeBodyWithJobs_many: "Retirer {{name}} de l'équipe ? {{count}} interventions en cours lui restent attribuées jusqu'à ce que vous les réattribuiez.",
removeBodyWithJobs_other: "Retirer {{name}} de l'équipe ? {{count}} interventions en cours lui restent attribuées jusqu'à ce que vous les réattribuiez.",
remove: "Retirer",
leaveBody: "Quitter {{team}} ? Il vous faudra une nouvelle invitation pour revenir.",
leave: "Quitter",
leaveFailedTitle: "Impossible de quitter l'équipe",
deleteBody: "Supprimer {{team}} ? Ses actifs, inspections et interventions reviennent à votre compte. Cette action est irréversible.",
delete: "Supprimer",
deleteFailedTitle: "Impossible de supprimer l'équipe",
renameFailedTitle: "Impossible de renommer l'équipe",
theMember: "Le membre",
noMemberMatches: "Aucun membre ne correspond.",
defaults: {
companyTitle: "Valeurs par défaut de l'entreprise",
companyHint: "Elles s'appliquent à toute votre entreprise. Vous pouvez aussi les modifier dans Compte → Paramètres.",
teamTitle: "Paramètres de cette équipe",
teamHint: "Utilisez les valeurs de l'entreprise ou définissez-en d'autres pour cette équipe.",
teamCurrency: "Devise de l'équipe",
teamSharing: "Comment cette équipe partage le travail",
sameAsCompany: "Comme l'entreprise",
setForTeam: "Définir pour cette équipe",
inUse: "En vigueur pour cette équipe",
},
errors: {
teamNotFound: "Équipe introuvable. Revenez en arrière et rouvrez-la.",
inviteNotFound: "Cette invitation est introuvable ou a expiré.",
invite: "Impossible d'envoyer l'invitation. Réessayez dans un instant.",
resend: "Impossible de renvoyer l'invitation. Réessayez dans un instant.",
accept: "Impossible de rejoindre l'équipe. Vérifiez que l'invitation est toujours ouverte et que vous êtes connecté avec l'adresse e-mail à laquelle elle a été envoyée.",
deleteTeam: "Impossible de supprimer l'équipe. Réessayez dans un instant.",
onlyOwnerDelete: "Seul le propriétaire de l'équipe peut la supprimer.",
transfer: "Impossible d'envoyer l'offre. Réessayez dans un instant.",
acceptTransfer: "Impossible d'accepter la propriété. Réessayez dans un instant.",
declineTransfer: "Impossible de refuser l'offre. Réessayez dans un instant.",
cancelTransfer: "Impossible d'annuler l'offre. Réessayez dans un instant.",
promote: "Impossible d'en faire un propriétaire. Réessayez dans un instant.",
demote: "Impossible de modifier son rôle. Réessayez dans un instant.",
alreadyMember: "Cette personne fait déjà partie de l'équipe.",
alreadyInvited: "Une invitation a déjà été envoyée à cette adresse e-mail.",
noAccount: "Votre espace de travail est encore en cours de configuration. Patientez un instant et réessayez.",
},
},
featuresScreen: {
  lockedRowA11y: "{{feature}}, bloqué par l'offre. Ouvre les offres qui l'incluent.",
  statusNotYet: "Pas encore disponible",
  title: "Fonctionnalités",
  subtitle: "Ce qui est activé dans cet espace de travail. Touchez une fonctionnalité bloquée par l'offre pour voir les offres qui l'incluent.",
  simplePresetTitle: "Préréglage Simple",
  simplePresetBody: "L'ensemble de départ pour une petite équipe : actifs, sites, demandes, inspections, interventions, revues, rapports, contacts et plans de maintenance. Analyses, prestataires, équipes, intégrations, IA et outils développeur sont désactivés, et chacun reste à un interrupteur d'ici.",
  simplePresetButton: "Utiliser le préréglage Simple",
  simplePresetConfirm: "Désactiver Analyses, Prestataires, Équipes, Intégrations, IA et Développeur pour cet espace de travail ? Chacun reste à un interrupteur.",
  simplePresetApplied: "Passé au préréglage Simple.",
  switchA11y: "{{feature}} : activer ou désactiver pour cet espace de travail",
  switchFailed: "La modification n'a pas été enregistrée. Vérifiez la connexion et réessayez.",
  adminHint: "Les propriétaires et administrateurs changent les fonctions ici ; les autres voient ce qui est actif.",
  statusEnabled: "Activée",
  statusDisabled: "Désactivée",
  statusLockedPlan: "Verrouillée par le forfait",
  statusRestrictedRole: "Restreinte par le rôle",
  statusDisabledAdmin: "Désactivé pour cet espace de travail",
  statusBeta: "Bêta",
  statusDependency: "Nécessite une autre fonctionnalité",
  statusUnavailable: "Non disponible",
  statusSetByAssetwrxOn: "Activé par AssetWRX",
  statusSetByAssetwrxOff: "Désactivé par AssetWRX",
  statusLoading: "Vérification…",
  modules: "Modules",
  capabilities: "Fonctionnalités",
  empty: "Aucune fonctionnalité à afficher pour le moment.",
  planLabel: "Forfait : {{plan}}",
  planUngated: "Forfait : aucune limite appliquée",
},
featureCatalog: {
modules: {
assets: { title: "Actifs" },
sites: { title: "Sites" },
requests: { title: "Demandes" },
inspections: { title: "Inspections" },
jobs: { title: "Interventions" },
reviews: { title: "Validations" },
reports: { title: "Rapports" },
analytics: { title: "Analytique" },
contacts: { title: "Contacts" },
contractors: { title: "Entrepreneurs" },
teams: { title: "Équipes" },
automation: { title: "Automatisation" },
integrations: { title: "Intégrations" },
ai: { title: "IA" },
administration: { title: "Administration" },
settings: { title: "Paramètres" },
developer: { title: "Développeurs" },
},
capabilities: {
  asset_360: { title: "Asset 360", description: "Le rapport Asset 360 : avis général, tableau de bord, sections pour le lecteur choisi, plan d’action et qualité des données, avec une version IA sur demande." },
  site_360: { title: "Site 360", description: "Le rapport Site 360 : tout le site, ses bâtiments et zones, conformité, risque, travaux et prestataires, avec une version IA sur demande." },
  esg: { title: "ESG et durabilité", description: "Énergie, carbone, DPE et fluides frigorigènes (gaz fluorés) pour les sites et équipements, avec une vue portefeuille et un chapitre ESG dans Site 360 et Asset 360. Une option payante." },
  esg_ai_writeup: { title: "Synthèse ESG par IA", description: "Une synthèse ESG rédigée avec des actions proposées, produite par l’IA à partir des chiffres ESG. Utilise des crédits." },
group_rules: { title: "Règles de groupe", description: "Des règles qui planifient la même checklist sur chaque actif correspondant, et la conservent sur les actifs ajoutés ensuite." },
rounds: { title: "Tournées", description: "Une intervention qui parcourt une checklist sur plusieurs actifs, dans l’ordre." },
contractor_inspections: { title: "Inspections par des prestataires", description: "Confiez une inspection à un prestataire ayant un compte AssetWRX ; elle apparaît dans son travail et il la réalise avec la même liste de contrôle." },
sub_jobs: { title: "Sous-interventions", description: "Une intervention peut contenir des sous-interventions, chacune avec sa personne ou son sous-traitant, sa date, ses vérifications et ses coûts ; l’intervention principale les attend." },
custom_asset_types: { title: "Types d’actifs et champs personnalisés", description: "Vos propres types d’actifs avec leurs propres champs, au-delà de Lieu, Équipement, Véhicule et Autre." },
bulk_asset_setup: { title: "Création en masse et modèles de bâtiment", description: "Créer de nombreux lieux ou actifs en une fois, ou tout un bâtiment à partir d’un modèle." },
contact_import: { title: "Import de contacts", description: "Importer des contacts depuis le carnet d’adresses du téléphone ou un fichier." },
ai_checklist_generation: { title: "Génération de checklists par IA", description: "Rédiger une checklist avec l’IA à partir d’une description, d’une photo ou d’un document." },
assistant_changes: { title: "L’assistant peut modifier les données", description: "L’assistant prépare des actifs, sites, inspections, interventions et règles de groupe, nouveaux ou modifiés, qu’une personne confirme." },
assistant_planning: { title: "Planification et optimisation par l’assistant", description: "L’assistant planifie les journées, équilibre la charge, propose des créneaux et conseille sur les programmes de maintenance." },
assistant_insights: { title: "Analyses et synthèses de l’assistant", description: "L’assistant explique tendances, coûts et causes, prépare des rapports et fournit une synthèse hebdomadaire." },
assistant_photo: { title: "Questions photo à l’assistant", description: "Interroger l’assistant sur une photo que vous prenez ou choisissez." },
assistant_voice: { title: "Voix de l’assistant", description: "Parler à l’assistant et entendre ses réponses (nécessite la dernière version de l’app sur le store)." },
feature_requests: { title: "Demandes de fonctionnalités", description: "Demander une fonctionnalité, suivre vos demandes et voter pour les idées que nous étudions." },
qr_codes: { title: "Codes QR", description: "Générer et scanner des codes QR pour identifier les actifs." },
barcode_scan: { title: "Lecture de codes-barres", description: "Scanner des codes-barres pour rechercher ou saisir des identifiants d’actifs." },
condition_intelligence: { title: "Intelligence de l’état", description: "État des actifs fondé sur des règles, recommandations de risque et adéquation des techniciens sur l’actif et dans le planificateur." },
location_tracking: { title: "Suivi de localisation", description: "Historique de localisation de l’actif et positions signalées par les inspections, les interventions et les sources connectées." },
knowledge_base: { title: "Base de connaissances", description: "Guides pratiques, FAQ, notes et fichiers sur un actif, recherche de connaissances sur tous les actifs et liens de partage sans connexion." },
approvals: { title: "Approbations", description: "Circuits d’approbation et de tri pour les demandes et les clôtures." },
photo_capture: { title: "Prise de photos", description: "Prendre des photos comme justificatifs dans les inspections, les interventions et les demandes." },
video_capture: { title: "Capture vidéo", description: "Joindre de courtes vidéos comme justificatifs." },
drawing: { title: "Dessin / annotation", description: "Annoter les photos avec des dessins et des légendes." },
voice_dictation: { title: "Dictée vocale", description: "Dicter des notes et du contenu terrain à la voix." },
speech_recognition: { title: "Reconnaissance vocale", description: "Transcription de la parole sur l’appareil pour la dictée vocale." },
ml_kit: { description: "Briques d’apprentissage automatique sur l’appareil (étiquettes, codes-barres, texte)." },
evidence_intelligence: { title: "Intelligence des justificatifs", description: "Analyser les justificatifs de travail localement, en ne faisant appel à l’IA qu’à la demande." },
wrx_vision: { description: "Scanner un groupe ou un point d’inspection ; lecture sur l’appareil des compteurs, identifiants et codes-barres, avec des suggestions vérifiées avant tout enregistrement." },
wrx_vision_cloud: { title: "Analyse cloud WRX Vision", description: "Analyse dans le cloud d’un scan Vision : état, défauts et contrôles non observés selon les critères de la check-list." },
wrx_vision_pack_fleet: { title: "Pack flotte WRX Vision", description: "Contrôles des dommages sur les véhicules : bosses, rayures, vitrages, feux, pneus et roues." },
wrx_vision_pack_equipment: { title: "Pack équipements WRX Vision", description: "Contrôles des machines et équipements : protections, fuites, flexibles, câbles, corrosion, plaques et compteurs." },
wrx_vision_pack_property: { title: "Pack immobilier WRX Vision", description: "Contrôles des pièces et bâtiments : humidité, développement de type moisissure, fissures, vitrages, équipements et accès." },
wrx_vision_pack_safety: { title: "Pack équipements de sécurité WRX Vision", description: "Contrôles visuels des équipements de sécurité : extincteurs, alarmes, signalétique et accès. Ne certifie jamais." },
wrx_vision_training_share: { title: "Données d’amélioration WRX Vision", description: "Activé par défaut : les photos justificatives des suggestions Vision examinées servent à améliorer Vision. Le propriétaire de l’espace de travail peut le désactiver." },
wrx_verified: { description: "Justificatifs de fin d’intervention : résultats attendus, photos avant/après et contrôle des justificatifs tranché par le valideur." },
work_intelligence: { title: "Intelligence du travail", description: "Analyse partagée des justificatifs de travail dans tous les flux." },
work_planning: { description: "Planifier qui fait quoi, quand et dans quel ordre : calendrier des personnes dans le temps, capacité, déplacements, disponibilité des pièces et des compétences, et plans suggérés qu’une personne applique." },
schedule_exceptions: { title: "Gouvernance du planning", description: "Demandes du terrain pour sauter, replanifier ou réaffecter un travail planifié, et les décisions associées." },
compliance_register: { title: "Registre de conformité", description: "Registre à l’échelle de l’espace de travail des certificats, renouvellements et justificatifs en retard." },
journey_intelligence: { title: "Intelligence des parcours", description: "Narration et analyses par IA des parcours opérationnels." },
journey_analytics: { title: "Analytique des parcours", description: "Tableaux de bord et entonnoirs des parcours sur l’ensemble du portefeuille." },
power_bi_export: { title: "Export Power BI", description: "Exporter les jeux de données analytiques pour Power BI." },
quotes: { title: "Devis", description: "Demander, comparer et choisir des devis d’entrepreneurs." },
scheduling: { title: "Planification", description: "Planification au calendrier et travaux planifiés." },
recurring_work: { title: "Travaux récurrents", description: "Inspections récurrentes et plans de maintenance préventive." },
maintenance_programmes: { title: "Programmes de maintenance", description: "Programmes de maintenance en plusieurs étapes, au compteur, au calendrier et par étapes successives." },
csv_import: { title: "Import CSV", description: "Importer des contacts et des actifs depuis un fichier CSV." },
excel_import: { title: "Import Excel", description: "Importer des données structurées depuis des classeurs Excel." },
power_automate: { description: "Déclencher des flux Power Automate à partir d’événements de la plateforme." },
iot_connectors: { title: "Connecteurs IoT", description: "Recevoir des signaux IoT pour déclencher du travail." },
embed: { title: "AssetWRX intégré", description: "Afficher des vues AssetWRX choisies (Travail, Actifs, inspections, interventions, rapports) dans un autre portail, sans l’habillage de l’app AssetWRX." },
embed_interactive: { title: "Intégrations interactives", description: "Permettre aux vues AssetWRX intégrées de mettre à jour des actifs, de réaliser des inspections et de modifier des interventions, et pas seulement de les afficher." },
ai_summary: { title: "Résumés IA", description: "Résumés et brouillons générés par l’IA sur tous les écrans." },
ai_assistants: { title: "Assistants IA", description: "Assistants et copilotes IA interactifs." },
field_ai_assist: { title: "Aide IA dans les champs", description: "Dicter, améliorer et résumer dans un champ de texte, là où vous travaillez." },
industry_packs: { title: "Packs sectoriels", description: "Installer des packs choisis de check-lists et de plans de maintenance, avec des suggestions de packs par actif." },
offline_mode: { title: "Mode hors ligne", description: "Travailler hors ligne avec synchronisation automatique à la reconnexion." },
notifications: { title: "Notifications", description: "Notifications dans l’app, push et par e-mail." },
rest_api: { description: "Accès à l’API REST propriétaire." },
graphql: { description: "Accès à l’API GraphQL." },
webhooks: { title: "Webhooks sortants", description: "S’abonner à des webhooks sortants signés." },
mcp: { description: "Accès via le Model Context Protocol pour les intégrations à base d’agents." },
},
},
shellTabs: {
industryPacks: "Packs sectoriels",
assetTypes: "Types d’actifs",
features: "Fonctionnalités",
overview: "Vue d’ensemble",
organization: "Organisation",
defaults: "Valeurs par défaut",
teams: "Équipes",
reports: "Image de marque",
integration: "Intégrations",
},
integrationHub: {
  ownerOnly: "Seul le propriétaire de l’espace de travail, {{owner}}, peut configurer les intégrations, les clés d’API et l’accès IA. Vous voyez ce qui est connecté ; demandez à {{owner}} de configurer le reste.",
  ownerOnlyUnnamed: "Seul le propriétaire de l’espace de travail peut configurer les intégrations, les clés d’API et l’accès IA. Vous voyez ce qui est connecté ; demandez au propriétaire de configurer le reste.",
askOwnerSetup: "Demandez à {{owner}} de le configurer.",
askOwnerSetupUnnamed: "Demandez au propriétaire de l’espace de travail de le configurer.",
tryAgainShortly: "Réessayez dans un instant.",
loadOfflineHint: "Vérifiez que cet appareil est en ligne, puis réessayez.",
conditionInvalidTitle: "Vérifiez cette condition",
conditionInvalidBody: "Pour une liste, saisissez les valeurs entre crochets, par exemple [\"Ouvert\", \"En retard\"].",
recipeDraftCreated: "Brouillon de recette enregistré. Activez-le quand vous êtes prêt.",
retryQueued: "Nouvelle tentative lancée. Le résultat apparaît dans l’historique des exécutions.",
importRowFailed: "La ligne {{row}} n’a pas pu être enregistrée. Vérifiez ses valeurs.",
importCustomTypeUnknown: "Ligne {{row}} : aucun type d’actif « {{name}} » pour cette catégorie, enregistré sans type.",
importSitsInMissing: "Ligne {{row}} : « {{name}} » introuvable pour l’y placer. Enregistré, dans rien.",
importSitsInNotAllowed: "Ligne {{row}} : ne peut pas se trouver dans « {{name}} » (un lieu seulement dans un lieu, un véhicule dans rien). Enregistré, dans rien.",
importFileUnreadableTitle: "Impossible de lire le fichier",
importFileUnreadable: "Enregistrez-le au format CSV ou Excel, puis choisissez-le à nouveau.",
importFailed: "L’import s’est arrêté. Vérifiez votre fichier, puis sélectionnez Relancer l’import.",
apiErrors: {
sessionExpired: "Votre session n’est plus valide. Reconnectez-vous, puis réessayez.",
ownerOnly: "Seul le propriétaire de l’espace de travail peut configurer les intégrations, les clés d’API et l’accès IA. Demandez-lui de le faire.",
forbidden: "Vous n’avez pas l’autorisation de faire cela.",
sourceInactive: "Cette source connectée n’est pas active. Réactivez-la ou renouvelez le jeton avant de réessayer.",
mcpAuth: "La connexion IA n’a pas pu s’authentifier. Vérifiez sa clé, puis réessayez.",
mcpUnreachable: "Impossible de joindre le serveur MCP. Vérifiez l’URL, les identifiants et l’accès réseau, puis réessayez.",
sourceToken: "Ce jeton de source de données n’est pas valide pour cet espace de travail.",
mcpRuntime: "La connexion IA n’a pas pu aboutir. Vérifiez son adresse et sa clé, puis réessayez.",
mcpAdmin: "Impossible de mettre à jour la connexion IA. Vérifiez les informations et réessayez.",
automationRun: "Le test ou la nouvelle tentative de l’automatisation n’a pas abouti. Vérifiez la configuration et réessayez.",
automationAdmin: "Impossible d’enregistrer l’automatisation. Vérifiez votre saisie et réessayez.",
connectedIngest: "Le message de l’appareil n’a pas été accepté. Vérifiez le jeton et les références d’actifs envoyées, puis réessayez.",
connectedAdmin: "Impossible de mettre à jour cette source de données. Vérifiez la source, la règle ou le message, puis réessayez.",
workspaceAdmin: "Impossible d’enregistrer ce réglage. Réessayez ou demandez au propriétaire de l’espace de travail.",
generic: "La demande n’a pas abouti. Veuillez réessayer.",
},
  importRetry: "Relancer l’import",
  importExcelFeature: "Import Excel",
  importRetrying: "Nouvelle tentative…",
  importStopped: "Arrêt à la ligne {{row}} : {{message}} Cette ligne et les suivantes n’ont pas été importées.",
  importWizard: {
  step: {
  file: "Fichier",
  object: "Objet",
  map: "Correspondance",
  preview: "Aperçu",
  done: "Terminé",
  },
  skip: "— Ignorer —",
  noDefault: "— Aucune valeur par défaut —",
  optionalDefault: "Valeur par défaut facultative…",
  sampleLeadDownload: "Première importation ? Téléchargez un exemple prêt à l’emploi (colonnes et valeurs valides).",
  sampleLeadCopy: "Première importation ? Copiez un exemple prêt à l’emploi (colonnes et valeurs valides).",
  sampleAssetsDownload: "Télécharger l’exemple d’actifs",
  sampleAssetsCopy: "Copier l’exemple d’actifs",
  sampleContactsDownload: "Télécharger l’exemple de contacts",
  sampleContactsCopy: "Copier l’exemple de contacts",
  sampleAssetsA11yDownload: "Télécharger le CSV d’exemple pour importer des actifs",
  sampleAssetsA11yCopy: "Copier le CSV d’exemple pour importer des actifs",
  sampleContactsA11yDownload: "Télécharger le CSV d’exemple pour importer des contacts",
  sampleContactsA11yCopy: "Copier le CSV d’exemple pour importer des contacts",
  sampleCalloutDownload: "Feuilles de calcul d’exemple : téléchargez les fichiers d’exemple de l’étape 1 ou ci-dessous.",
  sampleCalloutCopy: "Feuilles de calcul d’exemple : copiez les fichiers d’exemple de l’étape 1 ou ci-dessous.",
  formatReferenceShow: "Afficher la référence complète du format de données",
  formatReferenceHide: "Masquer la référence complète du format de données",
  },
webhookSecretIssued: "Nouvel identifiant de webhook émis. Copiez-le maintenant — il ne sera plus jamais affiché.",
webhookSecretReveal: "Afficher",
webhookSecretHide: "Masquer",
webhookSecretCopy: "Copier",
webhookSecretCopied: "Copié",
webhookSecretDismiss: "Fermer",
webhookSecretHiddenA11y: "Identifiant de webhook, masqué. Utilisez Afficher pour le montrer.",
webhookSecretRevealedA11y: "Identifiant de webhook, visible à l'écran.",
breadcrumb: "Compte · Espace de travail · Intégrations",
breadcrumbShort: "Espace de travail · Intégrations",
titleShort: "Centre d'intégrations",
hintShow: "Astuces de l'onglet",
hintHide: "Masquer les astuces",
eyebrow: "Intégrations de l’espace de travail",
title: "Intégrations prêtes pour l'entreprise",
metaLine: "Connectez vos outils métier avec des clés API, des webhooks et des automatisations simples.",
contextHintApis: "API d'abord : créez des clés sécurisées, vérifiez les portées et ouvrez la référence API en direct.",
contextHintApisGateway: "Clés API et accès : la gestion utilise votre session connectée via la passerelle de l’espace de travail. Créez les clés étape par étape, vérifiez la connexion, puis ouvrez la référence en direct.",
contextHintMcp: "MCP de l'espace de travail : enregistrez des serveurs externes approuvés, chiffrez les identifiants, découvrez les métadonnées et gardez l'historique des invocations auditable.",
contextHintImport: "Import de données : importez des feuilles de calcul et mappez vos enregistrements rapidement.",
contextHintAutomations: "Déclencheurs d’événements : recettes et historique d’exécution. Créez les comptes de service et les clés API dans Clés API et accès — pas ici.",
contextHintConnected: "L'ingestion connectée a son propre onglet : créez des sources, renouvelez les jetons de chaque source, examinez les événements entrants et les correspondances non résolues, puis configurez des règles. Utilisez Clés API et accès uniquement si vous voulez un compte de service de l'espace de travail plutôt que le jeton d'ingestion.",
contextHintConnectedShort: "Créez une source, copiez le jeton à usage unique depuis la fenêtre contextuelle, envoyez du JSON en POST vers l'URL d'ingestion, puis ajoutez des règles optionnelles. Les clés de compte de service se trouvent sous Clés API et accès.",
connectedAssetsLink: "Actifs connectés",
resourcesHelp: "Référence API (dans l'application)",
mainTabImport: "Import de données",
mainTabAutomations: "Déclencheurs d’événements",
mainTabApisAccess: "Clés API et accès",
mainTabMcp: "Serveurs MCP",
mainTabConnected: "Ingestion connectée",
guidedCategory: {
workflow: "Flux de travail quotidiens",
inspection: "Informer un autre système des inspections",
job: "Informer un autre système des interventions",
asset_sync: "Synchronisation des actifs",
inbound_webhook: "Recevoir d’un autre système",
scheduled: "Selon une planification",
outbound: "Tests",
},
journey: {
stage_choose: "Choisir",
stage_configure: "Configurer",
stage_authorise: "Autoriser",
stage_mapping: "Mapper",
stage_preview: "Aperçu",
stage_test: "Tester",
stage_activate: "Activer",
stage_monitor: "Surveiller",
stepCounter: "Étape {{current}} sur {{total}}",
back: "Retour",
next: "Continuer",
finish: "Terminer",
close: "Fermer",
loading: "Chargement…",
testing: "Traitement en cours…",
succeeded: "Réussite",
failed: "Échec",
requestId: "ID de requête",
retry: "Réessayer",
nameLabel: "Nom de la connexion",
outcome_read: "Lire des données depuis AssetWRX",
outcome_read_desc: "L'autre système récupère les actifs, inspections ou interventions depuis AssetWRX.",
outcome_send: "Envoyer des données à AssetWRX",
outcome_send_desc: "L'autre système crée ou met à jour des enregistrements dans AssetWRX.",
outcome_listen: "Recevoir des événements d'AssetWRX",
outcome_listen_desc: "AssetWRX informe l'autre système lorsque des changements se produisent.",
outcome_combination: "Une combinaison",
outcome_combination_desc: "Bidirectionnel — lire, écrire et rester synchronisé.",
createAccess: "Créer un accès sécurisé",
accessCreated: "Accès sécurisé créé",
accessFailed: "Impossible de créer l'accès sécurisé",
keyExpiryLabel: "Expiration de la clé",
keyExpiry30: "30 jours",
keyExpiry90: "90 jours",
keyExpiry365: "1 an",
keyExpiryNever: "Jamais",
apiKeyLabel: "Clé API",
customScopesHint: "N'activez que les accès dont cette connexion a besoin.",
elevatedScopeHelp: "Besoin d'un accès illimité ? Vérifiez-le et créez-le dans la console avancée.",
matchField: "Correspondance des enregistrements",
matchExternalId: "Faire correspondre les actifs par ID externe",
idempotencyPolicy: "Les événements source répétés utilisent le même ID d'événement source, afin que les nouvelles tentatives ne créent pas de travail en double.",
conflictPolicy: "Quand les deux systèmes ont modifié un enregistrement",
conflictPolicyNote: "Votre équipe informatique intègre cette règle à la synchronisation ; AssetWRX l’affiche sur la page de la connexion. Pour éviter les doublons, la synchronisation recherche chaque actif par son ID externe avant d’en créer un.",
conflict_manual_review: "Demander à une personne",
conflict_manual_review_desc: "Le plus sûr. Votre système n’écrase pas un enregistrement modifié dans AssetWRX ; il le signale pour qu’une personne le vérifie.",
conflict_source_wins: "Votre système l’emporte",
conflict_source_wins_desc: "Votre système met à jour l’enregistrement AssetWRX qui a le même ID externe.",
conflict_assetwrx_wins: "AssetWRX l’emporte",
conflict_assetwrx_wins_desc: "Votre système laisse tels quels les enregistrements modifiés dans AssetWRX.",
previewTitle: "Vérifier avant de tester",
previewHint: "Confirmez l'objectif métier, l'accès et les règles de traitement. Le test n'activera pas la connexion.",
previewConnection: "Connexion",
previewAccess: "Accès",
previewDestination: "Destination",
previewEvents: "Événements",
previewScopeCount_one: "{{count}} portée à privilège minimal",
previewScopeCount_many: "{{count}} portées à privilège minimal",
previewScopeCount_other: "{{count}} portées à privilège minimal",
previewConflict: "Politique de conflit",
previewProviderDefault: "Valeur par défaut sécurisée du fournisseur",
previewRetry: "Nouvelles tentatives",
previewIdempotent: "Idempotent ; les événements en double sont ignorés",
secretOnce: "Copiez ceci maintenant — pour votre sécurité, il ne pourra plus être affiché.",
secretSaved: "Je l'ai enregistré de façon sécurisée",
copy: "Copier",
copied: "Copié",
testConnection: "Tester la connexion",
testStatusExplain: "Nous appellerons le point de terminaison de statut en lecture seule avec votre nouvelle clé pour confirmer qu'elle fonctionne. Rien n'est créé ni modifié.",
connected: "Connecté",
connectedDetail: "AssetWRX a accepté les identifiants et a répondu avec succès.",
connectionFailed: "Connexion échouée",
quickStartExplain: "Dirigez votre application vers cette URL de base et envoyez votre clé dans l'en-tête x-asset-inspector-key.",
baseUrlLabel: "URL de base",
firstRequestLabel: "Première requête",
quickStartKeyNote: "Remplacez YOUR_API_KEY par la clé que vous venez d'enregistrer. Nous ne la stockons jamais dans les exemples.",
ready: "Votre connexion est prête",
readyDetail: "Vous pouvez la gérer à tout moment depuis Vos connexions.",
activating: "Activation…",
activateFailed: "Votre connexion n’est pas encore active",
activateFailedDetail: "Sélectionnez Réessayer. Rien n’a encore été activé.",
done: "Terminé",
na_openGuides: "Ouvrir les guides développeur",
na_openReference: "Ouvrir la référence API",
na_setupEvents: "Configurer les événements",
na_createAutomation: "Créer une automatisation",
na_manageSource: "Gérer la source et les règles",
identifierExplain: "Chaque événement entrant doit indiquer à quel actif il appartient. Choisissez comment vos appareils identifieront les actifs.",
idKind_external: "ID externe",
idKind_qr: "Code QR",
createSource: "Créer une source de données",
sourceCreated: "Source de données créée",
sourceFailed: "Impossible de créer la source de données",
ingestTokenLabel: "Jeton d'ingestion",
ingestAddressLabel: "Adresse à laquelle les appareils envoient",
ingestHowTo: "Donnez à l’équipe des appareils cette adresse et le jeton d’ingestion. Chaque message est un POST HTTPS vers l’adresse, avec le jeton dans l’en-tête x-connected-source-token.",
sendAnotherTest: "Essayer un autre identifiant",
sendTestExplain: "Envoyez un événement de test sûr maintenant. Vous pouvez également saisir un de vos identifiants d'actif réels pour voir une correspondance en direct.",
testIdentifierLabel: "Identifiant d'actif (optionnel)",
sendTestEvent: "Envoyer l'événement de test",
eventMatched: "Événement reçu · actif trouvé",
eventMatchedDetail: "AssetWRX a accepté l'événement et l'a associé à l'actif correspondant.",
eventUnmatched: "Événement reçu · actif non identifié",
eventUnmatchedDetail: "Le pipeline fonctionne — nous n'avons simplement pas pu faire correspondre cet identifiant à un actif. Saisissez un identifiant d'actif réel, ou résolvez-le plus tard dans Événements connectés.",
eventFailed: "L'événement a été rejeté",
title_business: "Connecter un système métier",
business_choose_title: "Que connectez-vous ?",
business_choose_hint: "Donnez-lui un nom que vous reconnaîtrez et choisissez le type de système.",
business_outcome_title: "Que voulez-vous qu'il fasse ?",
business_outcome_hint: "Cela nous aide à recommander l'accès sécurisé approprié.",
business_mapping_title: "Mapper les enregistrements et les conflits",
business_mapping_hint: "Utilisez des identifiants externes stables et décidez de ce qui se passe lorsque les deux systèmes ont modifié un enregistrement.",
business_access_title: "Créer un accès sécurisé",
business_access_hint: "AssetWRX crée un compte de service et une clé API unique pour cette connexion.",
business_test_title: "Tester la connexion",
business_activate_title: "Terminer",
sys_erp: "ERP",
sys_crm: "CRM",
sys_finance: "Finance",
sys_maintenance: "Maintenance",
sys_data: "Plateforme de données",
sys_custom: "Application personnalisée",
sys_other: "Autre",
title_developer: "Créer une application personnalisée",
dev_choose_title: "Nommez votre application",
dev_choose_hint: "Cela identifie la clé API afin que vous puissiez la retrouver plus tard.",
dev_access_title: "Créer un accès sécurisé",
dev_access_hint: "Choisissez l’accès minimal dont cette application a besoin. L’accès sans restriction se trouve dans la console avancée.",
dev_quickstart_title: "Effectuer votre première requête",
dev_activate_title: "Terminer",
title_iot: "Connecter une source de données",
iot_choose_title: "Nommez la source",
iot_choose_hint: "Qu'est-ce qui envoie des données vers AssetWRX ?",
iot_configure_title: "Comment les actifs seront-ils identifiés ?",
iot_token_title: "Sécuriser la source",
iot_token_hint: "Les appareils envoient ce jeton dans l'en-tête x-connected-source-token.",
iot_test_title: "Envoyer le premier événement",
iot_activate_title: "Terminer",
src_device: "Appareil / capteur",
src_gateway: "Passerelle IoT",
src_platform: "Plateforme IoT",
src_external: "Système externe",
title_webhook: "Créer une connexion d'événements",
wh_choose_title: "Nommez cette connexion d'événements",
wh_choose_hint: "Lorsque quelque chose se produit dans AssetWRX, où devons-nous l'envoyer ?",
wh_configure_title: "Destination et événements",
wh_secret_title: "Générer le secret de signature",
wh_test_title: "Envoyer un événement de test",
wh_activate_title: "Activer",
destUrlLabel: "URL de destination",
destUrlError: "Saisissez une URL https:// valide.",
chooseEvents: "Quels changements devons-nous envoyer ?",
signingExplain: "Vérifiez cette signature à chaque envoi pour confirmer qu'il provient bien d'AssetWRX.",
signingSecretLabel: "Secret de signature",
generateSecret: "Générer le secret de signature",
webhookCreated: "Connexion d'événements créée",
webhookFailed: "Impossible de créer la connexion d'événements",
webhookTestExplain: "Envoyez maintenant un envoi de test signé à votre point de terminaison pour confirmer qu'il peut recevoir des événements.",
sendTestDelivery: "Envoyer l'envoi de test",
webhookTestSent: "Événement de test envoyé",
webhookTestDetail: "Votre point de terminaison a accepté un envoi {{event}} signé{{http}}.",
webhookTestRejected: "Votre point de terminaison n'a pas accepté l'événement de test",
webhookTestFailed: "Impossible d'envoyer l'événement de test",
na_viewDeliveries: "Voir les envois",
evtgrp_assets: "Actifs",
evt_asset_created: "Actif créé",
evt_asset_updated: "Actif mis à jour",
evt_asset_deleted: "Actif supprimé",
evtgrp_inspections: "Inspections",
evt_inspection_created: "Inspection créée",
evt_inspection_updated: "Inspection mise à jour",
evt_inspection_completed: "Inspection terminée",
evtgrp_wrx: "WRX (interventions)",
evt_job_created: "WRX créée",
evt_job_status: "Statut de la WRX modifié",
evt_job_completed: "WRX terminée",
evtgrp_contacts: "Contacts",
evt_contact_created: "Contact créé",
evt_contact_updated: "Contact mis à jour",
evtgrp_connected: "Données connectées",
evt_connected_received: "Événement connecté reçu",
evt_connected_unresolved: "Événement connecté sans correspondance",
evt_connected_alert: "Alerte connectée déclenchée",
title_automation: "Automatiser un processus",
auto_choose_title: "Que voulez-vous automatiser ?",
auto_choose_hint: "Choisissez un point de départ. Vous pourrez tout ajuster ensuite.",
auto_configure_title: "Créer l'automatisation",
auto_configure_hint: "Quelques choix, puis lisez la phrase — c’est exactement ce qui se passera.",
auto_test_title: "Tester l'automatisation",
auto_activate_title: "Terminer",
tmpl_inspection_issue: "Lorsqu'une inspection est terminée",
tmpl_wrx_completed: "Lorsqu'une WRX est terminée",
tmpl_wrx_status: "Lorsque le statut d'une WRX change",
tmpl_asset_changed: "Lorsqu'un actif change",
tmpl_scratch: "Partir de zéro",
tmpl_inbound_webhook: "Lorsqu'un autre système appelle votre webhook",
tmpl_action_create_wrx: "Créer une demande de travail (WRX)",
tmpl_action_send_event: "L'envoyer à votre webhook",
tmpl_action_notify: "Notifier un autre système",
tmpl_action_choose: "Vous choisissez dans le générateur",
tmpl_action_inbound_wrx: "Créer une WRX à partir de la demande",
automationCreateExplain: "Nous créerons cette automatisation en tant que brouillon. Vous ajoutez les conditions et actions exactes dans le générateur, puis vous l'activez.",
createAutomation: "Créer l'automatisation",
automationCreated: "Automatisation créée en brouillon",
automationFailed: "Impossible de créer l'automatisation",
automationTestExplain: "Exécutez l'automatisation une fois maintenant pour confirmer que le déclencheur est bien câblé. Les automatisations en brouillon ne se déclenchent pas seules.",
runTest: "Exécuter le test",
automationRan: "Exécution de test terminée",
automationRanDetail: "Statut d'exécution : {{status}}. Ajoutez des actions dans le générateur pour qu'elle effectue un travail.",
automationCreateExplain2: "Nous créerons cette automatisation avec son déclencheur et une première action, prête à tester et à activer.",
automationCreatedWithAction: "Automatisation créée",
automationDraftDetail: "Ajoutez dans le générateur les actions que celle-ci doit effectuer.",
automationInboundReady: "Votre URL de webhook entrant et votre jeton sont affichés ci-dessous. Copiez le jeton maintenant.",
automationDestUrlLabel: "Où devons-nous l'envoyer ?",
automationDestUrlHint: "Nous envoyons chaque événement correspondant en POST vers cette URL HTTPS, signé afin que vous puissiez le vérifier.",
automationInboundOnce: "Voici votre webhook entrant. Copiez le jeton maintenant - il ne pourra plus être affiché.",
automationInboundUrlLabel: "URL du webhook (POST ici)",
automationInboundTokenLabel: "Jeton secret",
autoJobTitle: "Demande de travail automatisée",
automationRanDetail2: "Statut d'exécution : {{status}}. Ceci a exécuté l'action de l'automatisation une fois avec des données d'exemple.",
automationRunFailed: "L'exécution de test a échoué",
na_openBuilder: "Ouvrir le générateur d'automatisation",
title_ai: "Connecter un agent IA",
ai_choose_title: "Nommez la connexion IA",
ai_choose_hint: "Par exemple, l'assistant ou l'agent que vous voulez connecter.",
ai_nameLabel: "Nommez cette connexion",
ai_modeLabel: "Comment voulez-vous vous connecter ?",
ai_modeFirstParty: "Laisser un assistant IA utiliser AssetWRX",
ai_modeFirstPartyDesc: "Activez le serveur MCP AssetWRX afin que les assistants approuvés puissent lire et proposer des actions en toute sécurité.",
ai_modeExternal: "Connecter un serveur MCP externe",
ai_modeExternalDesc: "Enregistrez un serveur MCP tiers par son URL afin qu'AssetWRX puisse appeler ses outils et ressources.",
mcpExternalExplain: "Saisissez l'URL HTTPS du serveur MCP et la façon dont AssetWRX doit s'y authentifier.",
mcpBaseUrlLabel: "URL du serveur",
mcpAuthLabel: "Authentification",
mcpAuthNone: "Aucune authentification",
mcpAuthBearer: "Jeton Bearer",
mcpAuthApiKey: "Clé API",
mcpAuthCustom: "En-tête personnalisé",
mcpHeaderNameLabel: "Nom de l'en-tête",
mcpSecretPlaceholder: "Secret / jeton",
mcpRegister: "Enregistrer le serveur",
mcpRegistered: "Serveur externe enregistré",
mcpRegisterFailed: "Impossible d'enregistrer le serveur",
mcpNoKeyExplain: "Cette connexion utilise les identifiants que vous venez de saisir pour le serveur externe. Aucune clé AssetWRX n'est nécessaire.",
mcpExternalTestExplain: "Nous allons nous connecter au serveur et lister les outils et ressources qu'il expose.",
mcpTestConnection: "Tester la connexion",
mcpTestFailed: "Impossible d'atteindre le serveur",
mcpConnected: "Connecté au serveur",
mcpDiscovered: "{{tools}} outils et {{resources}} ressources trouvés.",
ai_enable_title: "Autoriser l'accès IA",
ai_access_title: "Choisir le niveau d'accès",
ai_access_hint: "Choisissez ce que l'IA peut voir et faire. Elle ne peut que proposer des changements, qui nécessitent toujours une confirmation.",
ai_test_title: "Vérifier la connexion",
ai_activate_title: "Terminer",
mcpExplain: "Les assistants et agents IA approuvés peuvent lire en toute sécurité des informations AssetWRX sélectionnées et proposer des actions. Chaque changement proposé par une IA nécessite toujours une confirmation.",
mcpEndpointLabel: "Point de terminaison de connexion IA",
enableAi: "Activer l'accès IA",
mcpEnabled: "Accès IA activé",
mcpEnableFailed: "Impossible d'activer l'accès IA",
mcpVerifyExplain: "Nous confirmerons que la clé fonctionne et que le connecteur IA est accessible. Rien n'est modifié.",
verifyAi: "Vérifier la connexion IA",
mcpActive: "La connexion IA est active",
mcpDegraded: "Connexion IA activée",
mcpVerifyDetail: "La clé fonctionne et le connecteur IA a répondu. Les agents approuvés peuvent maintenant se connecter.",
mcpVerifyFailed: "Impossible de vérifier la connexion IA",
na_reviewActivity: "Examiner l'activité IA",
title_files: "Configurer l'échange de fichiers",
files_choose_title: "Nommez cette connexion de fichiers",
files_choose_hint: "Téléversez des documents et fichiers vers AssetWRX, ou téléchargez-les, avec des liens sécurisés à courte durée de vie.",
files_access_title: "Créer un accès sécurisé",
files_access_hint: "Opérations sur les actifs couvre le téléversement et le téléchargement ; Lecture uniquement couvre seulement le téléchargement.",
files_test_title: "Tester l'échange de fichiers",
files_activate_title: "Terminer",
na_openFilesGuide: "Ouvrir le guide des fichiers",
filesReady: "L'échange de fichiers est prêt",
filesReadOnlyDetail: "Cette clé peut télécharger des fichiers mais pas en envoyer : nous avons donc vérifié qu’elle se connecte. Les liens de téléchargement fonctionnent pour les fichiers déjà dans AssetWRX.",
filesReadyReadOnly: "L’échange de fichiers est prêt (téléchargement seul)",
filesBothDetail: "Les liens de téléversement et de téléchargement signés ont été émis avec succès.",
filesUploadDetail: "Un lien de téléversement signé a été émis. Les téléchargements utilisent le même mécanisme de lien sécurisé.",
filesTestFailed: "Impossible d'émettre les liens signés",
filesTestExplain: "Nous allons demander à AssetWRX un lien de téléversement signé à courte durée de vie avec votre nouvelle clé. Rien n'est téléversé — cela prouve simplement que la connexion peut déplacer des fichiers.",
filesObjectKey: "Clé d'objet exemple",
filesTest: "Tester l'échange de fichiers",
automationScratchExplain: "Nous créerons une automatisation vide que vous pourrez construire dans l’éditeur avancé.",
automationEventReady: "Prête à s’exécuter seule",
automationEventTestExplain: "Celle-ci s’exécute d’elle-même quand l’espace de travail fait ce qu’elle surveille. Rien à déclencher — chaque exécution apparaît dans son historique.",
},
home: {
eyebrow: "Intégrations de l'espace de travail",
title: "Que voulez-vous accomplir ?",
subtitle: "Choisissez le résultat métier. AssetWRX vous guidera pour la configuration sécurisée, le test et l'activation.",
resumeTitle: "Reprendre la configuration",
discardDraft: "Abandonner la configuration enregistrée",
card_business_title: "Connecter un autre système métier",
card_business_desc: "Connectez un ERP, un CRM, une plateforme financière, un système de maintenance ou une autre application métier.",
card_business_cta: "Connecter un système",
card_webhook_title: "Réagir lorsque quelque chose se produit",
card_webhook_desc: "Envoyez des événements à un autre système lorsqu’un actif, une inspection, une intervention ou une demande change.",
card_webhook_cta: "Créer une connexion d'événements",
card_automation_title: "Automatiser un processus",
card_automation_desc: "Effectuez automatiquement des actions lorsque quelque chose se produit dans AssetWRX ou dans un autre système connecté.",
card_automation_cta: "Créer une automatisation",
card_iot_title: "Connecter des capteurs et des appareils",
card_iot_desc: "Importez dans AssetWRX les relevés de capteurs et d'appareils et reliez-les au bon actif.",
card_iot_cta: "Connecter une source de données",
card_ai_title: "Connecter un agent IA",
card_ai_desc: "Autorisez les assistants et agents IA approuvés à travailler en toute sécurité avec AssetWRX.",
card_ai_cta: "Connecter l'IA",
card_developer_title: "Créer une application personnalisée",
card_developer_desc: "Utilisez l'API AssetWRX pour créer des applications et intégrations personnalisées.",
card_developer_cta: "Commencer à développer",
card_files_title: "Échanger des fichiers",
card_files_desc: "Téléversez des documents et fichiers vers AssetWRX, ou téléchargez-les, avec des liens sécurisés à courte durée de vie.",
card_files_cta: "Configurer l'échange de fichiers",
card_import_title: "Importer des enregistrements depuis une feuille de calcul",
card_import_desc: "Importez des actifs ou des contacts depuis un fichier CSV ou Excel. Mappez vos colonnes aux bons champs, prévisualisez, puis créez les enregistrements.",
card_import_cta: "Importer depuis un fichier",
card_power_bi_title: "Rapports dans Power BI",
card_power_bi_desc: "Chargez actifs, inspections et interventions dans Power BI ou Excel, actualisés selon votre planification.",
card_power_bi_cta: "Configurer Power BI",
card_power_automate_title: "Utiliser Power Automate",
card_power_automate_desc: "Lancez des flux Microsoft quand le travail change, et créez interventions et inspections depuis vos flux.",
card_power_automate_cta: "Configurer Power Automate",
tier_start_title: "Commencer simplement",
tier_start_subtitle: "Guidé pas à pas. Certains vous donnent une clé à transmettre à la personne qui gère l’autre système.",
tier_data_title: "Données, événements et automatisation",
tier_data_subtitle: "Déplacez des données, réagissez aux changements et automatisez le travail.",
tier_dev_title: "Développeur et IA",
tier_dev_subtitle: "Développez avec l'API et connectez des agents IA.",
connectionsTitle: "Vos connexions",
connectionsEmptyTitle: "Aucune connexion pour le moment",
connectionsEmptyDesc: "Choisissez un résultat ci-dessus pour connecter votre premier système.",
connectionsEmptyMember: "Le propriétaire de l’espace de travail configure les connexions.",
connectionsLoadFailed: "Impossible de charger vos connexions.",
connectionsRetry: "Réessayer",
lockedSubtitle: "Connectez d’autres systèmes, automatisez le travail et reliez des capteurs ou des agents IA.",
activityNever: "Aucune activité pour le moment",
status_draft: "Brouillon",
status_testing: "Test en cours",
status_active: "Actif",
status_paused: "En pause",
status_error: "Attention requise",
status_archived: "Inactif",
devToolsTitle: "Outils développeur",
dev_api_title: "Référence API",
dev_api_subtitle: "Parcourez la référence REST et GraphQL en direct.",
dev_docs_title: "Guides et documentation",
dev_docs_subtitle: "Guides orientés tâches, exemples et dépannage.",
dev_advanced_title: "Console avancée",
dev_advanced_subtitle: "Toutes les clés, l’accès IA, les automatisations et les données entrantes, au même endroit.",
dev_keys_title: "Clés d’API",
dev_keys_subtitle: "Créez, renouvelez et révoquez les clés de vos intégrations.",
dev_ai_title: "Accès des assistants IA",
dev_ai_subtitle: "Choisissez ce que les assistants IA externes peuvent voir et faire, et approuvez leurs modifications.",
devTitle: "Connecter, développer et automatiser",
devSectionTitle: "Développeur et référence",
devSectionSubtitle: "Pour les équipes qui connectent des systèmes directement, donnent accès à des assistants IA ou gèrent des clés.",
devSectionSubtitleApi: "Pour les équipes qui connectent des systèmes directement ou gèrent des clés.",
devSectionSubtitleMcp: "Pour les équipes qui donnent accès à des assistants IA, avec des guides pas à pas.",
devSectionSubtitleGuides: "Guides, exemples et dépannage pour vos intégrations.",
journeyUnavailableTitle: "Pas encore disponible",
journeyUnavailableDesc: "Ce parcours est en cours de mise en place. Veuillez revenir bientôt.",
},
connection: {
type_business_system: "Système métier",
type_event_webhook: "Webhook",
type_automation: "Automatisation",
type_iot_connected: "Capteurs et IoT",
type_ai_mcp: "Agent IA",
type_developer_app: "Application personnalisée",
type_file_exchange: "Échange de fichiers",
overview: "Aperçu",
lastActivity: "Dernière activité",
source: "Source",
sourceManaged: "Connexion gérée",
sourceDerived: "Dérivée d'une ressource existante",
whatsConnected: "Ce qui est connecté",
noResources: "Aucune ressource liée.",
activity: "Activité récente",
activityEmpty: "Aucune activité récente à afficher pour le moment.",
health_healthy: "Sain",
health_attention: "Attention requise",
health_inactive: "Inactif",
health_active: "Actif",
health_degraded: "Dégradé",
health_paused: "En pause",
health_revoked: "Révoqué",
healthTitle: "État de la connexion",
lastSuccess: "Dernier succès",
lastFailure: "Dernier échec",
noFailure: "Aucun enregistré",
affectedObjects: "Objets affectés",
recovery_manage: "Gérer la connexion",
recovery_recover: "Examiner l'échec et se reconnecter",
recovery_resume: "Reprendre la connexion",
recovery_review_history: "Consulter l'historique des accès",
notFoundTitle: "Connexion introuvable",
notFoundDesc: "Elle a peut-être été supprimée. Retournez à l'accueil des intégrations.",
actionFailed: "Impossible de mettre à jour la connexion.",
archiveTitle: "Révoquer l'accès de la connexion ?",
archiveMsg: "L'accès s'arrêtera immédiatement. La configuration et l'historique d'activité resteront disponibles pour audit.",
archive: "Révoquer l'accès",
pause: "Mettre en pause",
activate: "Activer",
openAdvanced: "Ouvrir dans la console avancée",
kind_service_account: "Clé d’API",
kind_webhook_subscription: "Connexion d'événements (webhook)",
kind_connected_source: "Source de données connectée",
kind_mcp_server: "Serveur IA / MCP",
kind_automation_recipe: "Recette d'automatisation",
},
docs: {
title: "Guides et documentation",
subtitle: "Guides orientés tâches, exemples fonctionnels et dépannage.",
notFound: "Guide introuvable",
achieve: "Ce que vous allez accomplir",
need: "Ce dont vous avez besoin",
steps: "Étapes",
verify: "Comment savoir si ça a fonctionné",
failure: "En cas d'échec",
next: "Que faire ensuite",
rawHandbook: "Manuel brut (avancé)",
minutes_one: "{{count}} min",
minutes_many: "{{count}} min",
minutes_other: "{{count}} min",
minutesRead_one: "{{count}} min de lecture",
minutesRead_many: "{{count}} min de lecture",
minutesRead_other: "{{count}} min de lecture",
section: {
gettingStarted: { title: "Bien démarrer", description: "Connectez votre premier système et faites votre premier appel." },
guides: { title: "Guides pratiques", description: "Connectez les systèmes et plateformes courants, étape par étape." },
api: { title: "API", description: "REST, GraphQL, authentification, erreurs et identifiants de requête." },
events: { title: "Événements", description: "Webhooks sortants, signatures, nouvelles tentatives et idempotence." },
automation: { title: "Automatisation", description: "Déclencheurs, conditions et actions." },
connected: { title: "Données connectées", description: "Envoyez des données d’appareils et de capteurs et associez-les aux actifs." },
aiMcp: { title: "IA et MCP", description: "Laissez des agents IA approuvés travailler avec AssetWRX en toute sécurité." },
security: { title: "Sécurité", description: "Moindre privilège, rotation des clés et historique d’audit." },
troubleshooting: { title: "Dépannage", description: "Résolvez les problèmes d’intégration les plus courants selon le symptôme." },
},
guide: {
integrationOverview: { title: "Vue d’ensemble des intégrations", summary: "Comment AssetWRX se connecte à d’autres systèmes." },
connectFirstSystem: { title: "Connecter votre premier système", summary: "Créez un accès sécurisé et vérifiez qu’il fonctionne." },
authentication: { title: "Authentification", summary: "Comment authentifier les requêtes API." },
makeFirstRequest: { title: "Faire votre première requête API", summary: "Appelez l’API et lisez une réponse réussie." },
connectErp: { title: "Connecter un ERP", summary: "Donnez à votre ERP (ou à un autre système métier) son propre accès sécurisé à AssetWRX, puis confiez la suite côté ERP à l’informatique.", time: "20 min, plus le temps de l’informatique" },
connectPowerAutomate: { title: "Connecter Power Automate", summary: "Créez des interventions et inspections AssetWRX depuis vos flux Microsoft, et lancez un flux dès qu’un élément change dans AssetWRX." },
connectPowerBi: { title: "Rapports dans Power BI", summary: "Importez vos actifs, inspections et interventions dans Power BI ou Excel, actualisés selon un planning." },
embedInAPortal: { title: "Afficher AssetWRX dans un autre portail", summary: "Intégrez des écrans AssetWRX (Travail, un actif, une inspection, une intervention) dans votre portail client ou votre intranet.", time: "15 min pour vous, plus votre équipe web" },
embedInDynamics: { title: "Afficher AssetWRX dans Dynamics 365", summary: "L’actif AssetWRX sur le formulaire Customer Asset de Dynamics 365, connecté avec Microsoft, qui actualise le formulaire une fois le travail terminé.", time: "30 min pour vous, environ une heure pour l’informatique" },
sendIotData: { title: "Envoyer des données de capteurs et d’appareils", summary: "Laissez des capteurs, passerelles ou un autre système envoyer des relevés et alertes vers AssetWRX, associés au bon actif.", time: "15 min, plus le temps de l’équipe appareils" },
receiveEvents: { title: "Recevoir les événements AssetWRX", summary: "Faites envoyer par AssetWRX un message à un autre système dès qu’un actif, une inspection, une intervention ou une demande change.", time: "15 min, plus le temps de l’informatique" },
connectAiAgent: { title: "Connecter un agent IA", summary: "Laissez un assistant IA approuvé lire vos informations AssetWRX et demander des modifications qu’une personne approuve.", time: "15 min, plus la configuration de l’outil IA" },
uploadDownloadFiles: { title: "Téléverser et télécharger des fichiers", summary: "Laissez un autre système envoyer des fichiers à AssetWRX et les récupérer, avec des liens sécurisés à courte durée de vie.", time: "10 min, plus le temps de l’informatique" },
restApi: { title: "API REST", summary: "Ressources, méthodes et formats." },
paginationErrors: { title: "Pagination, erreurs et identifiants de requête", summary: "Lisez les listes page par page et diagnostiquez les échecs." },
permissionsScopes: { title: "Autorisations et portées", summary: "Ce que chaque portée permet." },
webhooks: { title: "Les webhooks", summary: "Fonctionnement des envois sortants." },
signatureVerification: { title: "Vérification de signature", summary: "Confirmez qu’un envoi provient bien d’AssetWRX." },
automationGettingStarted: { title: "Automatisation : bien démarrer", summary: "Déclencheurs, conditions et actions." },
assetMatching: { title: "Correspondance des actifs", summary: "Comment les événements sont reliés aux actifs." },
unresolvedEvents: { title: "Événements non résolus", summary: "Corrigez les événements qui ne correspondent à aucun actif." },
mcpOverview: { title: "Vue d’ensemble IA et MCP", summary: "Fonctionnement des connexions IA." },
mcpSecurity: { title: "Sécurité IA et modèle d’approbation", summary: "Gardez l’accès IA sûr." },
leastPrivilege: { title: "Moindre privilège", summary: "N’accordez que ce dont une connexion a besoin." },
keyRotation: { title: "Rotation et révocation des clés", summary: "Remplacez ou désactivez des clés en toute sécurité." },
auditHistory: { title: "Historique d’audit", summary: "Voyez qui a fait quoi." },
apiRejected: { title: "Mon appel API est refusé", summary: "Erreurs 401 / 403 et de validation." },
webhookNotArriving: { title: "Mon webhook n’arrive pas", summary: "Les envois n’atteignent jamais votre point de terminaison." },
eventNoAsset: { title: "Mon événement ne trouve pas d’actif", summary: "Les événements connectés restent non résolus." },
automationDidNotRun: { title: "Mon automatisation ne s’est pas exécutée", summary: "Une recette ne s’est pas déclenchée." },
aiCannotConnect: { title: "Mon agent IA ne se connecte pas", summary: "La connexion IA échoue." },
},
},
access: {
title: "Accès sécurisé",
notFound: "Le compte de service de cette connexion n'est pas disponible.",
keyCount: "{{active}} clé(s) active(s)",
statusActive: "Actif",
statusRevoked: "Révoqué",
permissions: "Autorisations",
keys: "Clés API",
keyLine: "{{scopeCount}} portées · créée le {{created}}",
expires: "expire",
rotate: "Renouveler la clé",
rotateFailed: "Impossible de faire la rotation de la clé.",
revokeFailed: "Révocation impossible. La clé fonctionne toujours.",
revoke: "Révoquer",
rotateTitle: "Renouveler cette clé ?",
rotateMsg: "La clé actuelle cesse de fonctionner dès maintenant. Donnez tout de suite la nouvelle clé à Power BI, Power Automate ou à votre système.",
revokeKeyTitle: "Révoquer cette clé ?",
revokeKeyMsg: "Les appels qui l'utilisent cessent de fonctionner immédiatement.",
revokeAll: "Révoquer l'accès",
revokeAllTitle: "Révoquer tous les accès ?",
revokeAllMsg: "Le compte de service et toutes les clés sont révoqués immédiatement. Cette action est irréversible.",
done: "Je l'ai enregistré",
},
connected: {
title: "Ingestion connectée",
notFound: "La source de données de cette connexion n'est pas disponible.",
statusActive: "Actif",
statusPaused: "En pause",
statusDisabled: "Désactivé",
tokenEnding: "Jeton se terminant par {{last}}",
rotateToken: "Renouveler le jeton d'ingestion",
rotateFailed: "Impossible de faire la rotation du jeton.",
pause: "Mettre en pause",
resume: "Reprendre",
resolveFailed: "Impossible de résoudre l'événement.",
unresolvedTitle: "Nécessite une attention",
unresolvedEmpty: "Aucun événement non résolu.",
reasonAmbiguous: "Correspond à plusieurs actifs",
reasonNoMatch: "Aucun actif correspondant",
resolveWith: "Résoudre comme",
resolveInAdvanced: "Résoudre dans la console avancée",
rulesTitle: "Règles",
rulesEmpty: "Aucune règle pour le moment.",
manageRules: "Gérer les règles",
cancel: "Annuler",
newRule: "+ Nouvelle règle",
ruleNameLabel: "Nom de la règle (optionnel)",
ruleNamePlaceholder: "ex. Alerte de température élevée",
matchLabel: "Quels événements ?",
matchAll: "Tous les événements",
matchPrefix: "Commence par",
actionLabel: "Alors",
actionAlert: "Déclencher une alerte",
actionReposition: "Mettre à jour l'emplacement",
actionPublish: "Publier un événement",
actionJob: "Créer une WRX",
actionValueLabel: "Détail de l'action",
valueAlertPlaceholder: "Titre de l'alerte (optionnel)",
valueJobPlaceholder: "Titre de la WRX (optionnel)",
createRule: "Créer la règle (en pause)",
ruleCreateFailed: "Impossible de créer la règle.",
ruleUpdateFailed: "Impossible de mettre à jour la règle.",
ruleActivate: "Activer",
rulePause: "Mettre en pause",
ruleAdvancedNote: "Besoin de conditions ou d'un check-list ? Ouvrez la console avancée.",
eventsTitle: "Événements récents",
eventsEmpty: "Aucun événement reçu pour le moment.",
reprocess: "Retraiter",
reprocessFailed: "Impossible de retraiter l'événement.",
},
automation: {
title: "Automatisation",
notFound: "L'automatisation de cette connexion n'est pas disponible.",
status_active: "Actif",
status_paused: "En pause",
status_draft: "Brouillon",
status_archived: "Archivée",
trigger: "Déclencheur",
steps_one: "{{count}} action",
steps_many: "{{count}} actions",
steps_other: "{{count}} actions",
runResult: "Exécution de test : {{status}}",
runFailed: "Impossible d'exécuter l'automatisation.",
activate: "Activer",
pause: "Mettre en pause",
runNow: "Exécuter maintenant",
editInBuilder: "Modifier dans le générateur",
actionFailed: "L'action a échoué.",
historyTitle: "Historique des exécutions",
historyEmpty: "Aucune exécution pour le moment.",
retry: "Réessayer",
inboundTitle: "Webhook entrant",
inboundUrl: "URL du webhook (POST ici)",
inboundNone: "Générez un secret pour activer l'URL entrante.",
inboundToken: "Jeton secret (affiché une seule fois)",
rotateSecret: "Renouveler le secret",
lastRun: "Dernière exécution",
never: "Jamais",
nextRun: "Prochaine exécution",
testRun: "Exécution de test",
turnOn: "Activer",
edit: "Modifier",
hideSkipped: "Masquer les ignorées",
showSkipped_one: "{{count}} ignorée",
showSkipped_other: "{{count}} ignorées",
historyEmptyEvent: "Rien ne s’est encore produit — elle s’exécute d’elle-même quand l’espace de travail agit.",
historyOnlySkipped: "Toutes les exécutions jusqu’ici ont été ignorées.",
fix: "Corriger cette automatisation",
showSkipped_many: "{{count}} ignorées",
},
mcp: {
title: "Connexion IA (MCP)",
notFound: "Le serveur MCP de cette connexion n'est pas disponible.",
statusActive: "Actif",
statusDisabled: "Désactivé",
statusError: "Erreur",
toolsResources: "{{tools}} outils · {{resources}} ressources",
test: "Tester la connexion",
testOk: "Connecté · {{protocol}}",
testFail: "Connexion échouée",
discover: "Découvrir les métadonnées",
discovered: "{{tools}} outils · {{resources}} ressources",
discoverFailed: "Impossible de découvrir les métadonnées.",
enable: "Activer",
disable: "Désactiver",
invocationsTitle: "Activité récente",
invocationsEmpty: "Aucune activité pour le moment.",
manageAdvanced: "Gérer dans la console avancée",
actionFailed: "L'action a échoué.",
credentials: "Identifiants",
credentialsTitle: "Mettre à jour les identifiants",
credentialsSaved: "Identifiants mis à jour",
credentialsFailed: "Impossible de mettre à jour les identifiants.",
auth_none: "Aucune authentification",
auth_bearer: "Bearer",
auth_api_key: "Clé API",
auth_custom_header: "En-tête personnalisé",
headerName: "Nom de l'en-tête",
secretPlaceholder: "Secret / jeton",
saveCredentials: "Enregistrer les identifiants",
},
files: {
  title: "Fichiers échangés",
  empty: "Aucun fichier pour l’instant. Les fichiers que vos systèmes envoient vers cet espace de travail, par n’importe quelle connexion de fichiers, apparaissent ici.",
  loadFailed: "Impossible de charger les fichiers.",
  download: "Télécharger",
  downloadFailed: "Impossible de télécharger le fichier.",
},
webhook: {
  title: "Événements",
  unavailable: "L’abonnement aux événements de cette connexion n’a pas pu être chargé.",
  address: "Envoie à",
  secretEnding: "Secret de signature se terminant par {{last}}",
  secretLabel: "Secret de signature",
  replace: "Remplacer le secret de signature",
  replaceTitle: "Remplacer le secret de signature ?",
  replaceMsg: "Les événements sont signés avec le nouveau secret immédiatement : le système destinataire les refuse tant qu’il n’a pas le nouveau. Transmettez-le tout de suite.",
  replaceFailed: "Impossible de remplacer le secret de signature.",
},
embeddedApps: {
  refusal_other: "un problème est survenu au démarrage de la session. Réessayez ; si cela se répète, contactez l'assistance AssetWRX.",
  refusal_assertion: "la preuve d'identité envoyée par le portail n'a pas été acceptée. Demandez à votre équipe informatique de vérifier les réglages de connexion.",
  refusal_scope_denied: "le portail a demandé une action que cette application n'est pas autorisée à faire.",
  refusal_jit_refused: "la personne n'a pas pu être ajoutée automatiquement.",
  refusal_unknown_user: "la personne n'est associée à personne dans cet espace de travail.",
  refusal_jit_domain_refused: "le domaine de l'e-mail de la personne n'est pas dans la liste autorisée.",
  refusal_identity_unlinked: "un administrateur a dissocié cette personne. Associez-la à nouveau ci-dessous.",
  refusal_identity_collision: "cette connexion appartient déjà à quelqu'un d'autre ici.",
  refusal_user_disabled: "le compte AssetWRX de la personne est désactivé.",
  refusal_wrong_tenant: "la personne a utilisé un compte Microsoft d'une autre entreprise.",
  refusal_sso_required: "la personne ne s'est pas connectée avec Microsoft.",
  refusal_not_entitled: "l'offre de l'espace de travail n'inclut pas l'intégration.",
  refusal_view_not_permitted: "la vue nécessite une autorisation que cette application n'a pas.",
  refusal_not_a_member: "la personne n'est pas membre de cet espace de travail.",
  refusal_bootstrap_expired: "la personne a mis plus d'une minute à se connecter. Recharger la page du portail règle le problème.",
  lastRefusalReason: "Dernier refus : {{reason}}",
  viewNeedsScope: "Ces vues ne peuvent pas s'ouvrir tant que vous ne cochez pas leur autorisation dans « Ce qu'elle peut faire » : {{views}}.",
  viewsHelp: "Cocher une vue coche aussi l'autorisation dont elle a besoin dans « Ce qu'elle peut faire ».",
  disableMsg: "Tous les portails qui l'utilisent cessent immédiatement d'afficher AssetWRX et les sessions ouvertes se terminent. Vous pouvez le réactiver à tout moment.",
  disableTitle: "Désactiver {{name}} ?",
  removeOriginConfirm: "Retirer le site",
  removeOriginMsg: "Ce site cesse immédiatement d'afficher AssetWRX. Les personnes qui l'utilisent y verront un espace vide jusqu'à ce que vous l'ajoutiez à nouveau.",
  removeOriginTitle: "Retirer {{origin}} ?",
  removeOriginShort: "Retirer",
  outcomeCta: "Configurer une application intégrée",
  outcomeTitle: "Afficher AssetWRX dans un autre portail",
  ownerOnlyBodyUnnamed: "Demandez au propriétaire de votre espace de travail d'en ajouter une. Les guides ci-dessus montrent ce dont il aura besoin.",
  ownerOnlyBody: "Demandez à {{owner}} d'en ajouter une. Les guides ci-dessus montrent ce dont il aura besoin.",
  ownerOnlyTitle: "Seul le propriétaire de l'espace de travail peut configurer les applications intégrées",
title: "Applications intégrées",
subtitle: "Affichez AssetWRX dans un autre portail, comme Dynamics 365 ou un portail client. Choisissez les sites autorisés à l'héberger, les vues qu'ils peuvent ouvrir et ce que ces vues peuvent faire.",
cardSubtitle: "Afficher des vues AssetWRX dans un autre portail.",
guidePortal: "Comment le configurer",
guideDynamics: "Configurer Dynamics 365",
create: "Nouvelle application intégrée",
defaultName: "Application intégrée",
loadFailed: "Impossible de charger vos applications intégrées. Elles n’ont pas été modifiées.",
emptyTitle: "Aucune application intégrée",
emptyDesc: "Créez-en une pour choisir quel portail peut héberger AssetWRX et ce qu'il peut afficher.",
adminOnly: "Seuls les propriétaires et administrateurs de l'espace de travail peuvent gérer les applications intégrées.",
name: "Nom",
save: "Enregistrer",
statusActive: "Activée",
statusDisabled: "Désactivée",
enable: "Activer",
disable: "Désactiver",
publicId: "ID public",
publicIdHelp: "Le portail hôte transmet cet ID. Il n'est pas secret et n'accorde rien à lui seul.",
secretTitle: "Secret de l'hôte",
secretHelp: "Le serveur de votre portail l'utilise pour démarrer les sessions intégrées. Conservez-le sur le serveur, jamais dans une page web.",
secretNone: "Aucun secret. Le portail ne peut pas ouvrir AssetWRX tant que vous n'en avez pas créé un.",
secretSet: "Secret {{prefix}}… créé le {{date}}",
secretCreate: "Créer un secret",
secretRotate: "Remplacer le secret",
secretRotateTitle: "Remplacer le secret de l'hôte ?",
secretRotateMsg: "Le secret actuel cesse de fonctionner immédiatement. Mettez à jour le serveur de votre portail avec le nouveau.",
secretShownOnce: "Copiez-le maintenant. Il ne sera plus affiché.",
origins: "Sites autorisés",
originsHelp: "Adresses exactes uniquement, par exemple https://contoso.crm.dynamics.com. Les caractères génériques ne sont pas autorisés.",
originPlaceholder: "https://example.com",
addOrigin: "Ajouter un site",
removeOrigin: "Retirer {{origin}}",
noOrigins: "Aucun site. Rien ne peut héberger cette application tant que vous n'en ajoutez pas.",
originErrorWildcard: "Les caractères génériques ne sont pas autorisés. Ajoutez chaque site séparément.",
originErrorInvalid: "Saisissez une adresse comme https://portal.example.com, sans chemin.",
views: "Vues qu'elle peut ouvrir",
scopes: "Ce qu'elle peut faire",
interactiveOff: "Modifier des données nécessite les intégrations interactives dans votre offre. D'ici là, seule la consultation s'applique.",
userCeiling: "Personne n'obtient plus que son propre accès à AssetWRX.",
identityTitle: "Connexion",
identityModeAssetwrx: "Connexion AssetWRX",
identityModeSso: "SSO Microsoft Entra",
identityModeHost: "Fournie par l'hôte (entreprise)",
identityHelp_assetwrx: "Les personnes se connectent à AssetWRX dans le portail avec leur propre compte AssetWRX.",
identityHelp_sso: "Les personnes se connectent avec le compte Microsoft de leur organisation, dans le locataire ci-dessous. Les autres comptes et les autres locataires sont refusés.",
identityHelp_host: "Le serveur du portail atteste de la personne avec un jeton d'identité signé par votre fournisseur d'identité : aucune seconde connexion. La personne doit être liée à cet espace de travail, ou ajoutée automatiquement.",
idpEntra: "Microsoft Entra ID",
idpOidc: "Autre fournisseur OpenID Connect",
idpTenant: "ID de locataire Entra",
idpTenantHelp: "L'ID d'annuaire (locataire) de l'organisation. Les connexions de tout autre locataire sont refusées.",
idpIssuer: "Émetteur",
idpIssuerHelp: "L'adresse web qui identifie votre fournisseur de connexion. Votre équipe informatique la copie depuis les réglages du fournisseur. Elle commence par https://.",
idpAudience: "Audience",
idpAudienceHelp: "L'identifiant d'application que votre portail utilise auprès du fournisseur de connexion. Votre équipe informatique le copie depuis l'inscription de l'application chez le fournisseur.",
jitEnable: "Ajouter automatiquement les nouvelles personnes",
jitHelp: "Désactivé : seules les personnes déjà liées ou déjà membres peuvent ouvrir la vue du portail. Activé : les personnes du fournisseur d'identité rejoignent cet espace de travail à leur première arrivée. Une adresse e-mail qui a déjà un compte AssetWRX n'est jamais liée automatiquement.",
jitDomains: "Domaines de messagerie autorisés",
jitDomainsHelp: "Séparez-les par des virgules. Laissez vide pour autoriser toute personne connectée par le fournisseur d'identité.",
jitTeam: "Équipe des nouvelles personnes",
jitRole: "Les nouvelles personnes rejoignent en tant que membres, jamais en tant qu’administrateurs.",
sessionLifetime: "Durée de la session",
hoursShort: "{{count}} h",
identitySave: "Enregistrer les paramètres de connexion",
identityStats: "Sessions ouvertes : {{sessions}} · Personnes liées : {{identities}} · Refus (30 jours) : {{denied}}",
lastDenied: "dernier refus le {{date}}",
linkedIdentities: "Personnes liées",
noLinkedIdentities: "Personne n'est encore lié.",
linkedVia_admin: "Liée par un administrateur",
linkedVia_jit: "Ajoutée automatiquement",
linkedVia_sso: "Connexion Microsoft",
unlink: "Délier",
unlinkTitle: "Délier cette personne ?",
unlinkMsg: "Ses sessions intégrées se terminent maintenant, et le fournisseur d'identité ne peut plus la connecter ici tant qu'elle n'est pas liée à nouveau.",
linkSubject: "ID utilisateur du fournisseur d'identité",
linkSubjectHelp: "L'identifiant de la personne chez votre fournisseur de connexion (dans Microsoft Entra, son ID d'objet sur la page de l'utilisateur). Choisissez ensuite le membre ci-dessous.",
link: "Lier",
theme: "Apparence",
themeAssetwrx: "AssetWRX",
themeHost: "Comme l'hôte",
themeLight: "Clair",
themeDark: "Sombre",
viewWork: "Travail",
viewAssets: "Actifs",
viewAsset: "Actif",
viewInspection: "Inspection",
viewJob: "Intervention",
viewRequest: "Demande",
viewInspectionReport: "Rapport d'inspection",
viewJobReport: "Rapport d'intervention",
created: "Créée le {{date}}",
lastUsed: "Dernière utilisation {{date}}",
neverUsed: "Jamais utilisée",
delete: "Supprimer",
deleteTitle: "Supprimer {{name}} ?",
deleteMsg: "Les portails qui l'utilisent cessent de fonctionner immédiatement. Cette action est irréversible.",
cancel: "Annuler",
actionFailed: "L'enregistrement a échoué. Réessayez.",
},
apiKeys: {
create: "Créer une clé d’API",
defaultName: "Clé d’API",
createFailed: "Impossible de créer la clé. {{message}}",
address: "Adresse de l’API",
howPowerBi: "Dans Power BI, choisissez Obtenir les données → Flux OData, saisissez {{url}}/v1/odata, puis De base : n’importe quel nom d’utilisateur et cette clé comme mot de passe.",
howHeader: "Envoyez la clé dans l’en-tête x-asset-inspector-key à chaque requête.",
openGuide: "Ouvrir le guide de configuration",
done: "Terminé",
nameLabel: "Nom",
createButton: "Créer la clé",
manage: "Renouveler ou révoquer",
hide: "Masquer",
},
serviceAccounts: {
title: "Clés d’API",
subtitle: "Créez une clé pour Power BI, Power Automate ou votre propre système, puis renouvelez-la ou révoquez-la ici. Une clé n’est affichée qu’une fois.",
emptyTitle: "Aucune clé d’API pour le moment",
emptyDesc: "Créez une clé avec « Créer une clé d’API » ou depuis un parcours de connexion.",
revokeTitle: "Révoquer cet accès ?",
revokeMsg: "Le compte de service et toutes les clés sont révoqués immédiatement. Cette action est irréversible.",
lastUsed: "Dernière utilisation {{date}}",
neverUsed: "Jamais utilisé",
created: "créé le {{date}}",
},
aiSettings: {
title: "IA AssetWRX (MCP)",
subtitle: "Contrôlez ce que les assistants IA approuvés peuvent faire avec AssetWRX. Chaque changement proposé par une IA nécessite toujours une confirmation.",
exposure: "Accès IA",
statusEnabled: "Activé",
statusDisabled: "Désactivé",
enable: "Activer l'accès IA",
disable: "Désactiver",
endpointLabel: "Point de terminaison MCP",
approvalsLoadFailed: "Impossible de charger les demandes de l’IA en attente d’approbation.",
ttlLabel: "Expiration de la proposition",
ttlHours_one: "{{count}} heure",
ttlHours_many: "{{count}} heures",
ttlHours_other: "{{count}} heures",
ttlHour: "1 heure",
toolsTitle: "Outils",
toolsEmpty: "Aucun outil disponible.",
writeAction: "Peut apporter des changements (nécessite une confirmation)",
rowEnable: "Activer",
rowDisable: "Désactiver",
resourcesTitle: "Ressources",
resourcesEmpty: "Aucune ressource disponible.",
activityTitle: "Activité IA récente",
activityEmpty: "Aucune activité IA pour le moment.",
actionFailed: "Impossible de mettre à jour. Réessayez.",
},
connectedPanel: {
eyebrow: "Actifs connectés",
title: "Ingestion d'événements connectée",
subtitle: "Gérez les sources, examinez le trafic entrant, résolvez les correspondances ambiguës et ajoutez des règles. Utilisez d'abord l'assistant de configuration, puis les sections ci-dessous.",
},
connectedConfigWizard: {
eyebrow: "Configuration",
title: "Configurer l'ingestion connectée",
lead: "Cet assistant vous guide pour créer une source, sécuriser son jeton, copier l'URL d'ingestion et comprendre les règles optionnelles.",
pillWelcome: "Début",
pillSource: "Source",
pillEndpoint: "URL d'ingestion",
pillRule: "Règles",
pillComplete: "Terminé",
welcomeTitle: "Ce que vous configurez",
welcomeIntro: "Vous allez connecter un système externe (SCADA, passerelle, script) pour envoyer des événements JSON en POST dans cet espace de travail.",
welcomeStep1: "Créez une source connectée (boîte de réception logique).",
welcomeStep2: "Copiez le jeton d'ingestion à usage unique depuis la fenêtre contextuelle sécurisée — même principe que les clés API.",
welcomeStep3: "Copiez l'URL POST et un exemple de charge utile pour votre intégration.",
welcomeStep4: "Ajoutez éventuellement une règle : lorsque les événements correspondent à un motif, exécutez une action claire (brouillon, alerte ou notification).",
sourceTitle: "Créer une source connectée",
sourceLead: "Donnez à la source un nom convivial que votre équipe reconnaîtra. La clé interne doit être unique ; laissez vide pour la générer automatiquement.",
fieldSourceName: "Nom d'affichage",
placeholderSourceName: "ex. Automate usine Nord",
fieldSourceKey: "Clé interne (optionnel)",
hintSourceKey: "Lettres, chiffres et tirets uniquement. Utilisée dans les journaux et métadonnées — non visible par les expéditeurs.",
placeholderSourceKey: "ex. automate-usine-nord",
createSourceCta: "Créer la source et afficher le jeton",
creating: "Création en cours…",
defaultSourceName: "Source connectée {{n}}",
endpointTitle: "Envoyer les événements à cette URL",
endpointLead: "Votre expéditeur doit utiliser HTTPS POST avec du JSON. Privilégiez le jeton par source dans l'en-tête x-connected-source-token.",
postUrlLabel: "Votre URL d'ingestion",
copyPostUrl: "Copier la ligne POST",
copySampleJson: "Copier l'exemple JSON",
endpointNoSource: "Créez une source à l'étape précédente (ou utilisez Nouvelle source ci-dessus) pour voir votre URL d'ingestion ici.",
endpointHeaderHint: "En-tête requis lors de l'utilisation du jeton d'ingestion :",
endpointBearerHint: "Si vous utilisez plutôt un compte de service de l'espace de travail, envoyez Authorization: Bearer <clé API> avec les portées connected_*.",
openApiKeys: "Ouvrir Clés API et accès",
ruleStepTitle: "Règles (optionnel)",
ruleStepLead: "Les règles surveillent les événements entrants après leur stockage. Lorsqu'une clé d'événement correspond à votre motif, AssetWRX exécute une action — par exemple publier vers la boîte de sortie d'automatisation afin que les recettes puissent réagir.",
ruleStepHint: "Utilisez le générateur de règles ci-dessous pour choisir « quand » et « alors » en langage simple. Les nouvelles règles démarrent en pause afin que vous puissiez les examiner avant de les activer.",
completeTitle: "Vous êtes prêt à intégrer",
completeBody: "Faites défiler pour gérer les sources, inspecter les événements récents, résoudre les charges utiles sans correspondance et ajuster les règles. Faites la rotation du jeton d'ingestion à tout moment ; chaque rotation affiche le nouveau secret une fois dans la même fenêtre contextuelle.",
},
connectedIngestModal: {
title: "Jeton d'ingestion (affiché une seule fois)",
leadCreate: "Copiez ce jeton dans un gestionnaire de mots de passe ou un coffre-fort. Envoyez-le comme en-tête x-connected-source-token à chaque POST vers cette source.",
leadRotate: "Votre jeton d'ingestion précédent a cessé de fonctionner lors de la rotation. Copiez le nouveau jeton et mettez à jour chaque expéditeur avant la reprise du trafic.",
copiedTitle: "Copié",
copiedBody: "Valeur copiée dans le presse-papiers.",
missingTokenTitle: "Aucun jeton renvoyé",
missingTokenBody: "Le serveur n'a pas renvoyé de nouveau jeton d'ingestion. Réessayez ou consultez les journaux de la fonction Edge.",
},
connectedRules: {
builderTitle: "Créer une règle connectée",
builderSubtitle: "Les règles répondent à : « Quand un événement ressemble à ceci, faire cela. » Les motifs utilisent des clés d'événement (par exemple telemetry.temperature ou connected.*). Les actions ne s'exécutent qu'après le stockage d'un événement ; plusieurs actions nécessitent que l'événement corresponde déjà à un actif.",
fieldRuleName: "Nom de la règle (optionnel)",
placeholderRuleName: "ex. Notifier à l'arrivée de télémétrie",
whenLabel: "Quand les événements entrants correspondent",
whenHint: "Choisissez la rigueur de correspondance de la clé d'événement. La plupart des équipes commencent avec « Tout événement connecté » ou un court préfixe.",
matchAll: "Tout événement connecté",
matchPrefix: "Préfixe",
matchCustom: "Motif avancé",
placeholderPrefix: "ex. telemetry (devient telemetry.*)",
customHint: "Utilisateurs avancés : saisissez un motif complet tel que connected.* ou job.status_changed.",
thenLabel: "Alors, faire ceci",
actionTitle_outbox_publish: "Publier vers la boîte de sortie d'automatisation",
actionBody_outbox_publish: "Émet un événement de l'espace de travail que d'autres systèmes et recettes d'automatisation peuvent consommer — semblable à une diffusion webhook au sein d'AssetWRX.",
actionTitle_asset_alert: "Déclencher une alerte sur un actif",
actionBody_asset_alert: "Inscrit une entrée d'activité visible sur l'actif correspondant. Titre personnalisé optionnel.",
actionTitle_asset_reposition: "Mettre à jour l'emplacement de l'actif",
actionBody_asset_reposition: "Applique une position signalée par l'appareil. Un actif mobile se déplace sans notification ; pour tout actif censé rester en place, une demande de validation est envoyée à son responsable.",
actionTitle_inspection_create: "Créer un brouillon d'inspection",
actionBody_inspection_create: "Ouvre un brouillon d'inspection sur l'actif correspondant. Nécessite un UUID de check-list de liste de contrôle.",
actionTitle_job_create: "Créer un brouillon d'intervention",
actionBody_job_create: "Ouvre un élément de travail en brouillon lié à l'actif correspondant lorsque le résolveur en a trouvé un.",
fieldOutboxEventType: "Type d'événement de la boîte de sortie",
fieldAlertTitle: "Titre de l'alerte (optionnel)",
placeholderAlertTitle: "Par défaut, le résumé de l'événement si vide",
fieldChecklistTemplateId: "ID de la check-list de liste de contrôle",
hintChecklistTemplateId: "UUID d'une check-list de liste de contrôle existant dans cet espace de travail. Le brouillon d'inspection utilise cette check-list.",
placeholderUuid: "00000000-0000-0000-0000-000000000000",
fieldJobTitle: "Titre de l'intervention (optionnel)",
placeholderJobTitle: "Par défaut, un titre dérivé de l'événement",
sourceScopeLabel: "Appliquer cette règle à",
sourceScopeHint: "Toutes les sources, ou uniquement les événements d'une source ci-dessous.",
sourceAll: "Toutes les sources",
createRuleCta: "Créer la règle (démarre en pause)",
ruleCreated: "Règle créée",
defaultRuleName: "Règle pour {{pattern}}",
ruleDescriptionAuto: "Créée depuis le générateur de règles d'ingestion connectée.",
checklistRequiredTitle: "Check-list de liste de contrôle requis",
checklistRequiredBody: "Les brouillons d'inspection nécessitent un UUID de check-list de liste de contrôle. Collez-en un depuis les check-lists de votre espace de travail, ou choisissez une autre action.",
},
connectedSections: {
reload: "Recharger",
newSource: "Nouvelle source",
rotateToken: "Renouveler le jeton",
sourcesTitle: "Sources",
sourcesSubtitle: "Chaque source a sa propre URL d'ingestion et son propre cycle de vie de jeton.",
sourcesEmpty: "Aucune source connectée pour le moment.",
sourceActivity: "Dernière réception : {{received}} · Dernier événement : {{last}}",
never: "Jamais",
eventsTitle: "Événements récents",
eventsSubtitle: "Dernières charges utiles acceptées par l'API (le retraitement est sûr lorsqu'indiqué par le support).",
eventsEmpty: "Aucun événement connecté pour le moment.",
noSummary: "Aucun résumé de l'assistant pour le moment.",
assetLabel: "Actif",
unresolved: "non résolu",
reprocess: "Retraiter",
reprocessed: "Événement retraité",
unresolvedTitle: "File d'attente non résolue",
unresolvedSubtitle: "Événements qui n'ont pas pu être associés à un seul actif — résolvez manuellement, puis retraitez si nécessaire.",
unresolvedEmpty: "Aucun événement connecté non résolu.",
resolveFirst: "Résoudre d'abord",
candidates_one: "{{count}} actif candidat",
candidates_many: "{{count}} actifs candidats",
candidates_other: "{{count}} actifs candidats",
resolved: "Événement non résolu résolu",
noCandidateTitle: "Aucun candidat disponible",
noCandidateBody: "Cet événement non résolu n'a aucun actif candidat stocké à appliquer automatiquement.",
rulesListTitle: "Règles enregistrées",
rulesListSubtitle: "Activez une règle lorsque vous êtes satisfait de son motif et de son action. Les règles en pause ne s'exécutent jamais.",
rulesEmpty: "Aucune règle connectée pour le moment.",
pause: "Mettre en pause",
activate: "Activer",
noDescription: "Aucune description fournie.",
ruleActivated: "Règle active",
rulePaused: "Règle en pause",
executionsTitle: "Historique d'exécution",
executionsSubtitle: "Dernières exécutions de règles connectées avec statut d'audit.",
executionsEmpty: "Aucune exécution de règle connectée pour le moment.",
attempt: "tentative",
executionEvent: "Événement {{id}} · {{at}}",
alertActionTitle: "L'action d'administration connectée a échoué",
alertActionBody: "Une erreur s'est produite. Veuillez réessayer.",
healthTitle: "État des intégrations",
healthSubtitle: "État opérationnel, état des nouvelles tentatives et derniers résultats d’ingestion.",
healthLabel: "Santé",
lastSuccessLbl: "Dernière synchronisation réussie",
lastFailedLbl: "Dernier échec de synchronisation",
logsLbl: "Journaux / historique",
logsVal: "{{e}} événements · {{r}} exécutions",
retryFailed: "Réessayer le dernier événement ayant échoué",
copyPayload: "Copier la charge utile de test",
credsNote: "Identifiants : les jetons source ne sont révélés qu’une fois, puis affichés uniquement par leur préfixe et leurs quatre derniers caractères. Utilisez des clés de compte de service avec les portées connected_* pour les intégrations par jeton Bearer.",
needsAction: "Action nécessaire",
needsReview: "Révision nécessaire",
healthyLbl: "Sain",
notConfigured: "Non configuré",
errPrefix: "Erreur : {{m}}",
seeSummary: "Voir le résumé des résultats de l'exécution.",
},
automationSubGuided: "Guidé",
automationSubRuns: "Historique d’exécutions",
automationSubExpert: "Éditeur expert",
docsBarAutomationGuide: "Guide d'automatisation",
docsBarIntegrationsOverview: "Aperçu des webhooks et connexions",
docsBarBrowseApi: "Ouvrir la référence API en direct",
docsBarApiHandbook: "Guide complet des connexions",
docsBarOpenApiKeys: "Clés API et comptes de service",
docsBarConnectedPreview: "Aperçu connecté",
automationsKeysCalloutTitle: "Les comptes de service et les clés API ne se créent pas ici",
automationsKeysCalloutBody: "Utilisez l’onglet Clés API et accès pour créer des comptes de service, émettre des clés API, vérifier la passerelle et copier les points de terminaison. Cet onglet est réservé aux recettes d’automatisation et à l’historique d’exécution.",
automationsKeysCalloutCta: "Ouvrir Clés API et accès",
apiExplorerLead: "Référence en lecture seule de l’API publique. « Essayer » est désactivé dans cette visionneuse afin que vos identifiants ne soient pas exposés à des origines arbitraires (CORS). Utilisez Clés API et accès → Vérifier la connexion avec votre session, ou testez avec une clé de compte de service depuis le même écran.",
apiExplorerServerDescription: "API de l'espace de travail AssetWRX",
apiExplorerGoVerify: "Ouvrir Clés API et accès pour vérifier la connexion",
apiExplorerBack: "Retour",
apiExplorerPhoneTitle: "À explorer de préférence sur un grand écran",
apiExplorerPhoneBody: "La référence interactive de l’API est conçue pour une tablette ou un ordinateur. Ouvrez cette page sur l’un d’eux pour parcourir les points de terminaison et les check-lists. Vous pouvez toujours gérer les clés d’API ci-dessus et copier votre URL de base ci-dessous.",
apiExplorerBaseUrlLabel: "URL de base",
apiExplorerCovers: "Couvre les actifs et les lieux, les sites, les listes de contrôle, les inspections et leur planification, les interventions, les plans et programmes de maintenance, les contacts, les équipes, les analyses, les fichiers, les webhooks, l’automatisation, les appareils connectés, Power BI et les agents IA. Sites, listes de contrôle, planification, maintenance et équipes sont en lecture seule.",
apiExplorerSectionNeeds: "Option de l’offre : {{names}}.",
apiExplorerSectionOff: "Non inclus dans votre offre : {{names}} est désactivé pour cet espace de travail.",
apiExplorerNotInPlan: "Non inclus dans votre offre, ces appels sont donc refusés : {{sections}}.",
handbookTitleAutomation: "Guide d'automatisation (dans l'application)",
handbookTitleIntegrations: "Guide API et connexions (dans l'application)",
handbookLead: "Ce contenu est intégré à l'application à partir du Markdown canonique du dépôt du produit.",
handbookOpenHosted: "Ouvrir la copie hébergée",
handbookCopyMarkdown: "Copier le Markdown",
handbookCopyDoneTitle: "Copié",
handbookCopyDoneBody: "Le Markdown du guide a été copié dans votre presse-papiers.",
handbookCopyFailedTitle: "Copie échouée",
handbookCopyFailedBody: "Impossible de copier dans le presse-papiers sur cet appareil.",
handbookOpenFailedTitle: "Impossible d'ouvrir le lien",
handbookOpenFailedBody: "Vérifiez l'URL de la documentation hébergée dans les paramètres d'environnement de votre espace de travail.",
docsFallbackTitle: "Lien de documentation",
docsFallbackAutomationIntro: "La documentation hébergée n'est pas encore configurée. Vous pouvez copier ces chemins de référence internes pour vos archives ou pour les partager avec le gestionnaire des intégrations.",
docsFallbackApiIntro: "La documentation hébergée n'est pas encore configurée. Vous pouvez copier ces chemins de référence internes pour vos archives ou pour les partager avec le gestionnaire des intégrations.",
docsFallbackCopy: "Copier les chemins de référence",
docsFallbackClose: "Fermer",
docsPathAutomation: "Guide d'automatisation (référence interne)",
docsPathApi: "API et intégrations (référence interne)",
docsPathOpenApiYaml: "Contrat OpenAPI (référence interne)",
showAdvancedDetails: "Afficher les détails avancés",
hideAdvancedDetails: "Masquer les détails avancés",
loadingContracts: "Chargement des contrats d’intégration…",
retryLoad: "Réessayer le chargement",
navSectionMain: "Modules",
navSectionAutomation: "Vues des déclencheurs",
guidedBadge: "Guidé",
recipeListTitle: "Recettes de cet espace de travail",
recipeListSubtitle: "Activez, mettez en pause, dupliquez, archivez, exécutez avec du JSON optionnel, faites la rotation des jetons entrants et relancez depuis l'historique.",
recipeNoActions: "aucune action",
recipeListEmpty: "Aucune recette pour le moment.",
recipePause: "Mettre en pause",
recipePaused: "Recette en pause",
recipeActivate: "Activer",
recipeActive: "Recette active",
recipeManualRun: "Exécution manuelle",
recipeDuplicate: "Dupliquer",
recipeDuplicated: "Recette dupliquée",
recipeRotateToken: "Renouveler le jeton",
recipeTokenRotated: "Jeton du webhook mis à jour",
recipeArchive: "Archiver",
recipeArchived: "Recette archivée",
guidedWizard: {
title: "Automatisation guidée",
subtitle: "Choisissez une check-list, remplissez quelques champs, puis créez un brouillon enregistré sur le serveur. La modification avancée des recettes se fait dans Déclencheurs d’événements → Éditeur expert.",
publicApiLead: "Toutes les exécutions s'effectuent dans votre espace de travail sur l'API publique ; rien n'est simulé dans l'application.",
apisShortcutLabel: "Créer ou afficher les comptes de service et les clés API",
apisShortcutA11y: "Ouvrir Clés API et accès pour gérer les comptes de service et les clés API",
pillType: "Type",
pillBasics: "Bases",
pillReview: "Vérification",
pillArtifacts: "Test et enregistrement",
pillDone: "Terminé",
next: "Suivant",
back: "Retour",
categoryWorkflow: "Flux de travail quotidiens",
categoryInspection: "Inspections",
categoryJob: "Interventions",
categoryAssetSync: "Synchronisation des actifs",
categoryInboundWebhook: "Webhooks entrants",
categoryScheduled: "Planifié",
categoryOutbound: "Tests et notifications",
fieldName: "Nom",
placeholderName: "Nom interne court",
fieldDescription: "Description (optionnel)",
placeholderDescription: "Qui utilise ceci et quel système le reçoit",
fieldForwardUrl: "Transférer vers l'URL HTTPS",
fieldDestinationUrl: "URL HTTPS de destination",
fieldSigningSecret: "Secret de signature (optionnel)",
placeholderSigningSecret: "Laissez vide si votre récepteur ne vérifie pas le HMAC",
fieldFilterStatus: "Uniquement lorsque le statut de l'inspection est égal à (optionnel)",
placeholderFilterStatus: "ex. completed — laissez vide pour envoyer à chaque mise à jour",
fieldAssetEvent: "Événement d'actif",
fieldIntervalMinutes: "Intervalle (minutes)",
fieldJobIdPath: "Champ d'ID de l'intervention dans le corps JSON",
fieldStatusPath: "Champ de statut dans le corps JSON",
reviewWhen: "Quand : ",
reviewDo: "Faire : ",
reviewNeedFix: "Corrigez les erreurs dans Bases pour voir la recette compilée.",
artifactsLead: "Copiez le contrat YAML ou l'exemple JSON pour les partenaires. Quand vous êtes prêt, créez un brouillon — puis activez la recette et utilisez l'exécution manuelle avec du JSON depuis la liste ci-dessous.",
copyYaml: "Copier le contrat YAML",
manualRunHelp: "Aide sur l'exécution manuelle",
copySampleEvent: "Copier l'exemple de JSON d'événement de domaine",
copyManualInput: "Copier l'exemple d'entrée d'exécution manuelle",
saving: "Enregistrement…",
createDraftContinue: "Créer le brouillon et continuer",
draftCreatedAlert: "Brouillon d'automatisation créé",
turnedOnAlert: "Automatisation activée",
turnOn: "Activer",
saveDraft: "Enregistrer comme brouillon",
copiedTitle: "Copié",
copiedYamlBody: "Contrat YAML copié dans le presse-papiers.",
copiedEventBody: "Exemple de JSON d'événement copié.",
copiedManualBody: "Utilisez ce corps comme entrée lors de l'appel des exécutions manuelles après activation.",
successTitle: "Brouillon enregistré",
successBody: "Votre recette apparaît dans la liste ci-dessous. Activez-la quand vous êtes prêt, puis utilisez l'exécution manuelle pour tester avec du JSON.",
successBodyActive: "C'est activé. Chaque exécution apparaît dans l'historique de cette automatisation.",
createAnother: "Créer une autre",
alertNeedTypeTitle: "Choisissez un type",
alertNeedTypeBody: "Sélectionnez une check-list d'automatisation pour continuer.",
alertInvalidTitle: "Vérifiez les champs",
alertInvalidBody: "Remplissez les champs requis pour continuer.",
manualHarnessTitle: "Banc de test manuel",
manualHarnessBodyGeneric: "Créez un brouillon « Webhook de test manuel », activez-le, puis utilisez l'exécution manuelle sur la ligne de la recette avec l'exemple JSON.",
manualHarnessCreateFirstTitle: "Créer d'abord",
manualHarnessCreateFirstBody: "Enregistrez cette automatisation en brouillon depuis « Créer le brouillon et continuer », puis activez-la et utilisez « Exécution manuelle » sur la ligne de la recette avec l'exemple JSON.",
},
manualRunModal: {
title: "Exécution manuelle",
inputLabel: "Entrée JSON optionnelle (objet)",
run: "Mettre en file d'exécution",
cancel: "Annuler",
errorInvalidJson: "Saisissez du JSON valide ou laissez vide pour {}.",
errorNotObject: "L'entrée doit être un objet JSON (pas un tableau).",
successTitle: "Exécution manuelle mise en file",
successBody: "ID d'exécution : {{id}}\nStatut : {{status}}",
goToRuns: "Ouvrir l'historique des exécutions",
},
accessWizard: {
pageTitle: "Clés API et accès",
pageSubtitle: "Aperçu, vérifiez la passerelle, gérez les clés, créez une nouvelle clé, examinez les automatisations entrantes, puis copiez l'URL de base REST et les chemins. Rien ici ne contourne la sécurité de votre espace de travail.",
pillPurpose: "Aperçu",
pillVerify: "Vérifier",
pillAccounts: "Clés existantes",
pillCreate: "Nouvelle clé",
pillInbound: "Entrant",
pillEndpoints: "Points de terminaison",
purposeTitle: "Ce que vous pouvez connecter",
purposeBody: "Les clés API REST permettent aux systèmes de confiance de lire et d'écrire les données de l'espace de travail. Les webhooks sortants de la plateforme sont configurés séparément dans le guide de connexion. Les URL entrantes de recette sont pour les déclencheurs d'automatisation.",
openHandbook: "Ouvrir le guide complet des connexions",
verifyTitle: "Vérifier l'API de l'espace de travail (session)",
verifyLead: "Confirme que la même passerelle utilisée par l'application pour la gestion des intégrations est accessible avec votre connexion actuelle.",
verifyAppLoginVsApiKeyTitle: "Connexion à l’app vs clés API",
verifyAppLoginVsApiKeyBody: "Vous vous connectez à cette application avec votre compte utilisateur (la même session que le reste d’AssetWRX). Les clés API servent uniquement aux autres systèmes et scripts qui appellent l’API REST de l’espace de travail — elles ne remplacent pas la connexion ici.",
verifyConnection: "Vérifier la connexion",
verifying: "Vérification en cours…",
sessionVerifyOk: "Accessible. Espace de travail {{workspaceId}} · principal : {{principal}}",
accountsListTitle: "Comptes de service existants",
accountsListLead: "Les clés sont hachées en SHA-256 au repos ; le texte brut n'est affiché qu'une seule fois lors de la création ou de la rotation. Actualisez la liste après avoir créé une clé sur un autre appareil.",
accountsListSecretCalloutTitle: "Pourquoi la clé complète n’apparaît pas dans cette liste",
accountsListSecretCalloutBody: "Seul un hachage est stocké côté serveur. Le secret complet s’affiche une fois dans la fenêtre lors de la création ou du renouvellement — copiez-le alors dans un gestionnaire de mots de passe. Ci-dessous, vous voyez uniquement les noms de compte et les périmètres. Si vous avez fermé la fenêtre sans enregistrer, utilisez « Renouveler la clé » pour en émettre un nouveau.",
accountsAdminErrorHint: "Seuls les administrateurs de l’espace de travail peuvent lister ou créer des comptes de service et des clés API. Connectez-vous avec un compte administrateur, ou demandez à un propriétaire de vous accorder le rôle admin.",
refreshList: "Actualiser la liste",
refreshLoading: "Chargement…",
lastUsed: "Dernière utilisation {{when}}",
neverUsed: "Pas encore utilisée",
rotatedOn: "Clé renouvelée {{when}}",
revokedOn: "Révoquée {{when}}",
rotateKey: "Renouveler la clé",
revoke: "Révoquer",
revoked: "Révoqué",
noAccounts: "Aucun compte de service pour le moment.",
createTitle: "Créer un compte de service",
createLead: "Choisissez un nom, une description optionnelle, des portées et une expiration de clé optionnelle. Vous verrez la clé complète une seule fois — conservez-la dans un coffre-fort.",
endpointsTitle: "Passerelle REST et chemins",
endpointsLead: "Tous les appels REST versionnés passent par cette URL de base. Ajoutez les chemins du contrat (par exemple /v1/assets). Les URL entrantes d'automatisation sont distinctes et listées à l'étape Entrant.",
endpointsBaseLabel: "URL de base de la passerelle",
endpointsCopyBase: "Copier l'URL de base",
endpointsCopiedTitle: "Copié",
endpointsCopiedBody: "URL de base de la passerelle copiée dans le presse-papiers.",
endpointsExamplesTitle: "Exemples (relatifs à la base)",
endpointsExampleStatus: "GET /v1/status — état de santé de l'API de l'espace de travail (nécessite status:read pour les clés API)",
endpointsExampleAssets: "GET /v1/assets — lister les actifs (nécessite assets:read)",
endpointsExampleInbound: "Les automatisations entrantes utilisent des URL HTTPS par recette depuis l'étape Entrant, pas cette URL de base.",
endpointsExampleDocs: "Chaque chemin, paramètre de requête et forme de corps se trouve dans la référence OpenAPI en direct.",
endpointsAuthHint: "Depuis d'autres systèmes : envoyez l'en-tête apikey: <votre clé publiable AssetWRX> et Authorization: Bearer <votre clé API de compte de service>. Cette application utilise plutôt votre session de connexion.",
endpointsOpenReference: "Ouvrir la référence API en direct",
fieldName: "Nom",
fieldDescription: "Description (optionnel)",
fieldExpiry: "La première clé expire le (date ISO optionnelle)",
placeholderName: "Synchronisation nocturne ERP",
placeholderDescription: "Note interne",
saving: "Enregistrement…",
createShowKey: "Créer et afficher la clé",
inboundTitle: "Points de terminaison de recette entrants",
inboundLead: "Affiché pour les recettes qui utilisent le déclencheur webhook entrant. Les URL et secrets apparaissent sur la recette après activation.",
inboundToken: "Jeton {{prefix}}…{{last}}",
inboundEmpty: "Créez une recette avec le déclencheur webhook entrant pour générer un point de terminaison tokenisé.",
keyVerifyOk: "La requête de test avec cette clé a réussi (GET /v1/status).",
keyVerifyFail: "Impossible de vérifier la clé avec GET /v1/status : {{message}}",
keyVerifySkipped: "Ajoutez la portée « Statut de l'espace de travail » (status:read) pour vérifier automatiquement les nouvelles clés la prochaine fois.",
keyRevealModalTitle: "Votre nouvelle clé API",
keyRevealModalLead: "Copiez ce secret et enregistrez-le dans un gestionnaire de mots de passe. Vous ne pourrez plus afficher la clé complète dans cette liste.",
keyRevealCopy: "Copier la clé",
keyRevealSaved: "Je l’ai enregistrée",
keyRevealMissingFromServer: "Le serveur n’a pas renvoyé de clé. Réessayez ou consultez les journaux de la fonction Edge.",
keyRevealCopiedTitle: "Copié",
keyRevealCopiedBody: "Clé API copiée dans le presse-papiers.",
},
mcpWizard: {
pageTitle: "Serveurs MCP de l'espace de travail",
pageSubtitle: "Connectez des serveurs MCP distants approuvés en HTTPS, stockez les secrets chiffrés, exécutez la découverte depuis le backend, puis choisissez quels outils et ressources l'assistant peut proposer.",
flowLabel: "Configuration guidée",
pillIntro: "Aperçu",
pillServer: "Serveur",
pillCredentials: "Secrets",
pillVerify: "Test et découverte",
pillCatalog: "Liste d'autorisation",
pillHistory: "Historique",
loading: "Chargement de la configuration MCP…",
loadError: "Impossible de charger la configuration MCP.",
detailLoadError: "Impossible de charger les outils et ressources de ce serveur.",
introTitle: "Ce que vous configurez",
introLead: "Le Model Context Protocol (MCP) permet à l'assistant opérationnel d'appeler des outils externes et de lire des ressources externes après votre confirmation de chaque proposition. Cet espace de travail conserve une liste d'autorisation stricte.",
introWhatTitle: "Contraintes de la version 1",
introWhatBody: "Seuls les points de terminaison HTTP JSON-RPC distants sont pris en charge. Les identifiants sont chiffrés côté serveur ; l'application ne reçoit plus jamais les secrets en texte brut après l'enregistrement. La découverte et les appels passent toujours par la fonction Edge de l'API publique.",
introStepsTitle: "Suivez ces étapes dans l'ordre",
introStep1: "Enregistrez le nom du serveur et l'URL de base HTTPS documentée par votre fournisseur.",
introStep2: "Enregistrez les identifiants si le point de terminaison nécessite un jeton Bearer, un en-tête de clé API ou un en-tête personnalisé.",
introStep3: "Testez la connexion, puis exécutez la découverte afin que les outils et ressources apparaissent dans le catalogue.",
introStep4: "N'activez que les outils et ressources que cet espace de travail doit pouvoir invoquer.",
introStep5: "Activez éventuellement « Assistant » par ligne afin que le planificateur puisse proposer cet outil ou cette ressource (vous confirmez toujours avant l'exécution).",
introStep6: "Examinez l'historique des invocations pour les audits et le dépannage.",
serverListTitle: "Choisir ou ajouter un serveur",
serverListLead: "Sélectionnez une carte pour la modifier, ou utilisez « Ajouter un serveur MCP » pour une nouvelle ligne, puis enregistrez ci-dessous.",
serverCardCounts: "Outils : {{tools}} · Ressources : {{resources}}",
addServer: "Ajouter un serveur MCP",
serverFormTitle: "Détails du serveur",
serverFormLead: "Collez l'URL exacte du point de terminaison MCP fournie par votre fournisseur. Elle doit utiliser HTTPS — utilisez le format d'exemple ci-dessous en cas de doute.",
fieldName: "Nom",
fieldDescription: "Description (optionnel)",
fieldBaseUrl: "URL de base (HTTPS)",
fieldBaseUrlPlaceholder: "https://mcp.example.com/v1",
fieldBaseUrlHint: "Doit commencer par https://. Utilisez le chemin complet documenté par votre hôte MCP (souvent /mcp, /sse ou /v1). HTTP et les noms d'hôte nus ne sont pas pris en charge.",
alertBaseUrlHttpsTitle: "URL HTTPS requise",
alertBaseUrlHttpsBody: "L'URL de base MCP doit commencer par https://. Exemple : https://mcp.example.com/v1",
invalidBaseUrlFormat: "Saisissez une URL complète incluant https://, par exemple https://mcp.example.com/v1",
fieldTimeoutMs: "Délai d'expiration (ms)",
fieldMaxPayload: "Taille max de charge utile (octets)",
fieldHeaderName: "Nom de l'en-tête",
fieldSecret: "Secret",
secretPlaceholderNew: "Saisissez le secret une fois pour le chiffrer",
secretPlaceholderRotate: "Saisissez un nouveau secret pour faire la rotation de la valeur stockée",
saving: "Enregistrement…",
updateServer: "Mettre à jour le serveur",
createServer: "Créer le serveur",
serverSavedTitle: "Serveur MCP enregistré",
serverSavedBody: "{{name}} est enregistré. Passez à Secrets lorsque le point de terminaison nécessite une authentification.",
serverSaveFailedTitle: "Enregistrement échoué",
serverSaveFailed: "Impossible d'enregistrer le serveur MCP.",
credentialsTitle: "Identifiants chiffrés",
credentialsLead: "Choisissez comment le backend s'authentifie auprès du serveur MCP. N'utilisez « aucune » que pour les hôtes qui ne nécessitent pas de secret.",
credentialsNeedServer: "Enregistrez un serveur à l'étape précédente avant d'ajouter des identifiants.",
credentialStored: "Stocké : {{type}} {{prefix}}…{{last}}",
saveCredentials: "Enregistrer les identifiants",
credentialsSavedTitle: "Identifiants mis à jour",
credentialsSavedBody: "Les secrets sont chiffrés au repos. Seules des métadonnées masquées sont renvoyées à l'application par la suite.",
credentialsSaveFailedTitle: "Mise à jour des identifiants échouée",
credentialsSaveFailed: "Impossible d'enregistrer les identifiants.",
noSecretStored: "Aucun secret stocké",
verifyTitle: "Tester la connexion et découvrir",
verifyLead: "Le test effectue une prise de contact d'initialisation légère. La découverte liste les outils et ressources afin que vous puissiez les approuver.",
verifyOrderTitle: "Ordre recommandé",
verifyOrderBody: "Exécutez d'abord Tester la connexion. En cas de succès, exécutez Découvrir les métadonnées, puis passez à Liste d'autorisation pour activer les entrées.",
verifyNeedServer: "Enregistrez d'abord un serveur, puis revenez ici.",
testConnection: "Tester la connexion",
discoverMetadata: "Découvrir les métadonnées",
testOkTitle: "Test de connexion réussi",
testOkBody: "Terminé en {{ms}} ms.",
discoverOkTitle: "Découverte terminée",
discoverOkBody: "{{tools}} outils et {{resources}} ressources trouvés.",
testFailedTitle: "Test de connexion échoué",
discoverFailedTitle: "Découverte échouée",
actionFailedGeneric: "Impossible de terminer cette opération.",
catalogTitle: "Liste d'autorisation des outils et ressources",
catalogLead: "L'espace de travail active/désactive si le backend peut appeler une entrée. Les bascules Assistant ajoutent la visibilité pour le planificateur en plus de cela.",
catalogNeedServer: "Enregistrez un serveur et exécutez la découverte avant de gérer le catalogue.",
toolsHeading: "Outils",
resourcesHeading: "Ressources",
noTools: "Aucun outil découvert pour le moment. Exécutez Découvrir les métadonnées à l'étape précédente.",
noResources: "Aucune ressource découverte pour le moment. Exécutez Découvrir les métadonnées à l'étape précédente.",
workspaceOn: "Espace de travail activé",
workspaceOff: "Espace de travail désactivé",
assistantOn: "Assistant activé",
assistantOff: "Assistant désactivé",
historyTitle: "Historique des invocations",
historyLead: "Chaque appel enregistre la cible, le temps, le statut et des aperçus de charge utile assainis.",
noInvocations: "Aucune invocation MCP enregistrée pour le moment.",
invocationMeta: "Durée {{ms}} ms · {{when}}",
maskedLine: "Masque du dernier identifiant : {{mask}}",
alertNeedServerTitle: "Enregistrez d'abord un serveur",
alertNeedServerBody: "Créez ou sélectionnez un serveur, remplissez les champs requis, puis appuyez sur Créer le serveur ou Mettre à jour le serveur avant de continuer.",
alertServerFieldsTitle: "Vérifiez les champs requis",
alertServerFieldsBody: "Saisissez un nom d'affichage et une URL de base HTTPS avant de continuer.",
alertNoServerTitle: "Aucun serveur sélectionné",
alertNoServerBody: "Sélectionnez ou créez un serveur avant d'enregistrer des identifiants.",
toolUpdateFailedTitle: "Mise à jour de l'outil échouée",
toolUpdateFailed: "Impossible de mettre à jour l'outil MCP.",
resourceUpdateFailedTitle: "Mise à jour de la ressource échouée",
resourceUpdateFailed: "Impossible de mettre à jour la ressource MCP.",
},
editor: {
  saved: "Automatisation mise à jour",
  saveFailed: "Enregistrement impossible",
  title: "Modifier l’automatisation",
  notGuidedTitle: "Pas une automatisation guidée",
  notGuidedDesc: "Celle-ci a été créée dans l’éditeur avancé. Modifiez-la là-bas.",
  save: "Enregistrer",
},
guidedForm: {
  severityLabel: "Quand elle détecte",
  severityAny: "Tout problème",
  severityUrgent: "Problèmes urgents uniquement",
  checklistLabel: "Seulement pour cette liste de contrôle",
  anyChecklist: "Toute liste de contrôle",
  assignLabel: "Attribuer l’intervention à",
  nobodyYet: "Personne pour l’instant",
  urgencyLabel: "Urgence de l’intervention de renouvellement",
  urgencyDefault: "Normale",
  urgencyHigh: "Élevée",
  urgencyUrgent: "Urgente",
  thresholdLabel: "Interventions d’un montant égal ou supérieur à ({{currency}})",
  approverLabel: "Qui les valide",
  choosePerson: "Choisir une personne",
  daysLabel: "Sans réponse depuis",
  daysOption_one: "{{count}} jour",
  daysOption_other: "{{count}} jours",
  assetCreated: "Créé",
  assetUpdated: "Mis à jour",
  assetDeleted: "Supprimé",
  titlePathLabel: "Le titre de l’intervention vient de ce champ du JSON",
  unknownChoice: "N’est plus dans l’espace de travail",
  wholeTeam: "Toute l’équipe",
  notifyLabel: "Prévenir",
  nobody: "Personne",
  choosePersonOrTeam: "Choisir une personne ou une équipe",
  close: "Fermer",
  search: "Rechercher…",
  noMatch: "Aucun résultat.",
  daysOption_many: "{{count}} jours",
},
},
connectedAssets: {
title: "Actifs connectés",
lead: "Les connecteurs IoT et la télémétrie en direct apparaîtront ici. Zone réservée pour des fonctions futures.",
backToIntegrations: "Retour aux automatisations",
moreTitle: "Périmètre et feuille de route",
moreSummary: "Connecteurs, état des équipements et liens avec les automatisations.",
moreBody: "Les actifs connectés afficheront des relevés en direct, la dernière activité et des liens vers les inspections et interventions lorsque l’espace activera les intégrations. Utilisez les automatisations pour provisionner les connecteurs et gérer l’accès aux données.",
showMore: "Afficher plus",
showLess: "Afficher moins",
},
apiAccess: {
catalogScopesLabel: "Domaines d'accès API",
noScopes: "Aucun domaine d'accès sélectionné",
fullAccessChip: "Accès API complet",
scopesSectionTitle: "Ce que cette clé peut utiliser",
scopesSectionHint: "Choisissez un kit de démarrage pour les outils courants, puis affinez avec les cases à cocher. N'activez que ce dont votre intégration a besoin.",
presetsLabel: "Kits de démarrage",
preset_starter_title: "Rapports et listes",
preset_starter_subtitle: "Lire le statut de l'espace de travail, les actifs, inspections et interventions — idéal pour les tableaux de bord et la synchronisation en lecture seule.",
preset_field_title: "Opérations de terrain",
preset_field_subtitle: "Ajoute la création et la mise à jour des actifs, contacts, inspections et interventions — typique pour les outils mobiles ou d'équipe.",
preset_automation_title: "Automatisations et événements",
preset_automation_subtitle: "Inclut les recettes, le catalogue d'automatisation et la lecture des événements — pour les flux de type Zapier et les webhooks.",
preset_full_title: "Tout (administrateur)",
preset_full_subtitle: "Puissance API complète incluant GraphQL et la gestion d'autres clés. À utiliser uniquement pour des logiciels serveur de confiance.",
preset_read_only_title: "Lecture uniquement",
preset_read_only_subtitle: "Consulter le statut de l'espace de travail, les actifs, contacts, inspections, interventions et le flux d'événements. Rien ne peut être modifié.",
preset_power_bi_title: "Power BI",
preset_power_bi_subtitle: "Lire les actifs, inspections et interventions via le flux OData. Rien ne peut être modifié.",
preset_power_automate_title: "Power Automate",
preset_power_automate_subtitle: "Ce dont le connecteur Power Automate a besoin : lire les actifs ; lire et créer des interventions et des inspections ; lancer des flux à partir d’événements.",
preset_asset_operations_title: "Opérations sur les actifs",
preset_asset_operations_subtitle: "Créer et mettre à jour les actifs et contacts, avec accès en lecture aux check-lists — pour maintenir un registre d'actifs synchronisé.",
preset_inspections_title: "Inspections",
preset_inspections_subtitle: "Créer et mettre à jour les inspections, avec accès en lecture aux actifs, interventions et check-lists — pour les outils d'inspection.",
preset_wrx_operations_title: "Opérations WRX",
preset_wrx_operations_subtitle: "Lecture et écriture complètes sur les actifs, contacts, inspections et interventions (WRX) plus le flux d'événements — pour les systèmes opérationnels.",
preset_full_integration_title: "Intégration complète",
preset_full_integration_subtitle: "Accès API complet incluant GraphQL et la gestion des clés. À utiliser uniquement pour des logiciels serveur de confiance.",
preset_custom_access_title: "Personnalisé",
preset_custom_access_subtitle: "Choisissez exactement les domaines d'accès dont cette connexion a besoin.",
preset_ai_read_title: "Lire les informations sur les actifs",
preset_ai_read_subtitle: "Laisser l'agent IA lire les actifs, contacts, inspections et interventions. Il ne peut apporter aucun changement.",
preset_ai_inspection_title: "Assistant d'inspection",
preset_ai_inspection_subtitle: "Laisser l'agent IA lire les actifs et check-lists et créer ou mettre à jour des inspections.",
preset_ai_wrx_title: "Assistant WRX",
preset_ai_wrx_subtitle: "Laisser l'agent IA lire et mettre à jour les actifs, contacts, inspections et interventions (WRX).",
preset_ai_operations_title: "Assistant opérations",
preset_ai_operations_subtitle: "Accès opérationnel complet pour l'agent IA, incluant le contexte d'automatisation et d'événements connectés.",
preset_custom_ai_title: "Personnalisé",
preset_custom_ai_subtitle: "Choisissez exactement quels outils et informations cette connexion IA peut utiliser.",
group_overview: "Aperçu et assistant",
group_records: "Actifs, contacts, inspections et interventions",
group_events: "Webhooks et événements",
group_automation: "Générateur d'automatisation",
group_connected: "Sources, événements et règles connectés",
group_advanced: "Avancé et gestion des clés",
scope_status_read: "Statut de l'espace de travail",
scope_dashboard_read: "Données du tableau de bord",
scope_dashboards_read: "Tableaux de bord enregistrés",
scope_assistant_context_read: "Contexte de l'assistant (lecture)",
scope_assets_read: "Voir les actifs",
scope_assets_write: "Créer et modifier des actifs",
scope_contacts_read: "Voir les contacts",
scope_contacts_write: "Créer et modifier des contacts",
scope_inspections_read: "Voir les inspections",
scope_inspections_write: "Créer et modifier des inspections",
scope_jobs_read: "Voir les interventions",
scope_jobs_write: "Créer et modifier des interventions",
scope_templates_read: "Voir les check-lists",
scope_templates_write: "Créer et modifier des check-lists",
scope_mcp_read: "Voir les réglages IA (MCP)",
scope_mcp_write: "Gérer les réglages IA (MCP)",
scope_mcp_invoke: "Utiliser les outils IA (MCP)",
scope_connected_sources_read: "Voir les sources connectées",
scope_connected_sources_write: "Gérer les sources connectées",
scope_connected_events_read: "Voir les événements connectés",
scope_connected_events_write: "Envoyer des événements connectés",
scope_connected_rules_read: "Voir les règles connectées",
scope_connected_rules_write: "Gérer les règles connectées",
scope_webhooks_read: "Voir les webhooks sortants",
scope_webhooks_write: "Gérer les webhooks sortants",
scope_events_read: "Lire le flux d'événements",
scope_graphql_read: "GraphQL (lecture)",
scope_graphql_write: "GraphQL (écriture)",
scope_service_accounts_read: "Voir les clés API et comptes de service",
scope_service_accounts_write: "Gérer les clés API et comptes de service",
scope_automation_catalog_read: "Voir le catalogue d'automatisation",
scope_automation_recipes_read: "Voir les recettes",
scope_automation_recipes_write: "Créer et modifier des recettes",
scope_automation_runs_read: "Voir les exécutions de recettes",
scope_automation_actions_write: "Exécuter des actions d'automatisation",
alertNameTitle: "Nom requis",
alertNameBody: "Saisissez un nom court afin que votre équipe sache à quoi sert cette intégration.",
alertScopesTitle: "Choisissez au moins un domaine",
alertScopesBody: "Choisissez un kit de démarrage ou cochez un ou plusieurs domaines d'accès.",
alertExpiryTitle: "Vérifiez la date d'expiration",
alertExpiryBody: "Utilisez une date et heure valides, ou laissez l'expiration vide.",
alertStoreKeyTitle: "Copiez votre clé API maintenant",
alertStoreKeyBody: "C'est la seule fois où la clé complète est affichée. Conservez-la dans un gestionnaire de mots de passe ou un coffre-fort.\n\n{{key}}",
},
defaults: {
  memberNotice: "Seul un administrateur peut changer la langue et le fuseau horaire de l'espace de travail. Les vôtres se trouvent dans Préférences.",
  saveFailedBody: "Ce changement n'a pas été enregistré. Vérifiez votre connexion et réessayez.",
  saveFailedTitle: "Non enregistré",
  currencyHint: "Utilisée pour les coûts que vous saisissez. Elle vous est propre, pas à l'espace de travail ; une équipe peut définir la sienne.",
regionalSummary: "Paramètres régionaux par défaut",
regionalBody: "Les valeurs par défaut de l’espace de travail s’appliquent lorsqu’un membre laisse la langue ou le fuseau vide sur son profil. Les paramètres personnels priment toujours.",
workspaceDefaultLanguage: "Langue par défaut de l’espace de travail",
workspaceDefaultTimezone: "Fuseau horaire par défaut de l’espace de travail",
effectiveLanguage: "Votre langue effective",
effectiveTimezone: "Votre fuseau horaire effectif",
notSet: "Non défini",
openOrganization: "Modifier dans le profil organisation",
loading: "Chargement…",
orgHint: "Les valeurs par défaut se modifient dans le profil organisation. Elles utilisent les mêmes listes que les réglages personnels de langue et de fuseau horaire.",
categorySubtitle: "Valeurs par défaut pour votre espace de travail. Utilisées pour les inspections et les interventions ; les équipes peuvent les remplacer.",
shareMethodEmail: "E-mail",
languageOptionA11y: "Langue de l'espace de travail {{label}}",
timezoneOptionA11y: "Fuseau horaire par défaut de l’espace de travail",
currencyLabel: "Votre devise",
currencyOptionA11y: "Devise {{code}}",
shareMethodLabel: "Communication (méthode de partage)",
shareMethodOptionA11y: "Méthode de partage par défaut {{label}}",
teamOverridesA11y: "Ouvrir les paramètres et les remplacements de l'équipe",
teamOverridesLink: "Paramètres et remplacements de l'équipe",
searchTimezone: "Rechercher un fuseau",
},
organization: {
defaultLanguageLabel: "Langue par défaut",
timezoneLabel: "Fuseau horaire par défaut",
notSet: "Non défini",
languageHelper: "Utilisé lorsque la langue personnelle n’est pas définie : puis langue de l’appareil si prise en charge, puis anglais (États-Unis).",
timezoneHelper: "Utilisé lorsque le fuseau personnel n’est pas défini : puis fuseau de l’appareil, puis UTC.",
},
assetTypes: {
headerSubtitle: "Vos propres types d’actifs et de lieux, et les détails que chacun demande",
intro: "Ajoutez les types d’actifs que gère votre espace de travail, comme un groupe froid, une chambre d’hôtel ou un ascenseur, et les détails à renseigner pour chacun. Chaque actif de ce type demande les mêmes détails.",
add: "Ajouter un type d’actif",
addTitle: "Nouveau type d’actif",
editTitle: "Modifier le type d’actif",
nameLabel: "Nom",
namePlaceholder: "Par exemple Groupe froid ou Chambre",
nameRequired: "Donnez un nom au type",
kindLabel: "C’est un",
kindLocked_one: "Utilisé par {{count}} actif, sa catégorie reste donc la même.",
kindLocked_many: "Utilisé par {{count}} actifs, sa catégorie reste donc la même.",
kindLocked_other: "Utilisé par {{count}} actifs, sa catégorie reste donc la même.",
descriptionLabel: "Description",
descriptionPlaceholder: "Facultatif. Ce que couvre ce type",
fieldsLabel: "Détails à renseigner",
fieldsHint: "Chaque actif de ce type les affiche sur sa fiche et dans le formulaire de création.",
fieldLabel: "Nom du détail",
fieldPlaceholder: "Par exemple Fluide frigorigène ou Nombre de lits",
fieldKinds: {
text: "Texte",
number: "Nombre",
date: "Date",
choice: "Choisir dans une liste",
yes_no: "Oui ou non",
},
optionsLabel: "Choix",
optionsPlaceholder: "Séparés par des virgules, par exemple R410A, R32, R134a",
optionsRequired: "Ajoutez au moins un choix",
unitLabel: "Unité",
unitPlaceholder: "Facultatif, par exemple kW",
requiredLabel: "Obligatoire",
removeField: "Retirer le détail",
addField: "Ajouter un détail",
cancel: "Annuler",
save: "Enregistrer",
saved: "Type d’actif enregistré",
saveFailedTitle: "Impossible d’enregistrer le type d’actif",
saveFailedBody: "Vérifiez votre connexion et réessayez.",
fieldCount_one: "{{count}} détail",
fieldCount_many: "{{count}} détails",
fieldCount_other: "{{count}} détails",
usedBy_one: "utilisé par {{count}} actif",
usedBy_many: "utilisé par {{count}} actifs",
usedBy_other: "utilisé par {{count}} actifs",
archived: "Archivé",
edit: "Modifier",
archive: "Archiver",
restore: "Restaurer",
showArchived_one: "Afficher {{count}} type archivé",
showArchived_many: "Afficher {{count}} types archivés",
showArchived_other: "Afficher {{count}} types archivés",
hideArchived: "Masquer les types archivés",
emptyTitle: "Pas encore de types d’actifs à vous",
emptyBodyAdmin: "Ajoutez-en un pour donner à un type d’actif ses propres détails.",
emptyBody: "Un propriétaire ou un administrateur peut ajouter des types d’actifs à l’espace de travail.",
archiveConfirmTitle: "Archiver ce type d’actif ?",
archiveConfirmBody: "Les actifs qui l’utilisent le conservent avec leurs détails. Il n’apparaît plus lors de l’ajout de nouveaux actifs. Vous pouvez le restaurer à tout moment.",
},
industryPacks: {
  later: "Plus tard",
  onboardingFailedBody: "Les listes prêtes à l’emploi de votre métier ne sont pas toutes arrivées. Touchez Réessayer pour ouvrir les packs sectoriels et les ajouter.",
  onboardingFailedTitle: "Certaines listes n’ont pas été ajoutées",
  openTemplates: "Ouvrir les check-lists",
  perAssetNote: "Installer le pack ajoute les listes. Les plans d’entretien et les preuves à fournir sont proposés sur chaque actif concerné, à accepter sur place.",
title: "Packs sectoriels",
headerSubtitle: "Types d’actifs, checklists et plans de départ pour votre secteur",
subtitle: "Un point de départ préparé pour ce que vous gérez. Ajoutez ce qui sert, modifiez tout, retirez le reste.",
disclaimer: "Des suggestions pour démarrer, pas un conseil juridique. Vérifiez ce qui s’applique là où vous opérez.",
installed: "Installé",
notInstalled: "Non installé",
installedCount_one: "{{installed}}/{{count}} check-list",
installedCount_many: "{{installed}}/{{count}} check-lists",
installedCount_other: "{{installed}}/{{count}} check-lists",
newAvailable_one: "{{count}} nouvelle check-list disponible",
newAvailable_other: "{{count}} nouvelles check-lists disponibles",
install: "Installer le pack",
installing: "Installation…",
addRecommended: "Ajouter les check-lists recommandées",
upToDate: "Vous avez déjà tout ce pack.",
remove: "Retirer le pack",
removeConfirmTitle: "Retirer ce pack ?",
removeConfirmBody: "Les check-lists que vous avez modifiées restent. Seules les check-lists du pack non modifiées sont retirées, et l’actif d’exemple part avec le dernier pack.",
removeConfirmAction: "Retirer",
removedToast_one: "{{count}} check-list retirée.",
removedToast_other: "{{count}} check-lists retirées.",
removedSampleNote: "L’actif d’exemple a été retiré lui aussi.",
keptNote_one: "{{count}} check-list conservée car vous l’avez modifiée.",
keptNote_other: "{{count}} check-lists conservées car vous les avez modifiées.",
installedToast: "Listes ajoutées. Retrouvez-les dans Check-lists.",
partialToast: "Certains éléments n’ont pas pu être ajoutés. Réessayez.",
retry: "Réessayer",
sections: {
assetTypes: "Ce que vous pouvez ajouter",
templates: "Check-lists",
maintenance: "Maintenance",
compliance: "À justifier",
},
suggestions: {
title: "De votre pack sectoriel",
body: "Suggéré pour ce type d’actif. Rien n’est ajouté tant que vous ne le choisissez pas.",
addPlan: "Ajouter le plan",
planAdded: "Ajouté",
declare: "Suivre",
declared: "Suivi",
empty: "Plus rien à suggérer pour cet actif.",
},
packs: {
property: {
name: "Immobilier",
description: "Maisons, appartements et locaux — état des lieux, entrée et sortie, sécurité incendie et les attestations correspondantes.",
},
fleet: {
name: "Flotte",
description: "Voitures, fourgons, camions et remorques — contrôles quotidiens, dommages, remise et entretien par date ou kilométrage.",
},
equipment: {
name: "Équipements",
description: "Machines, outils et engins — contrôles avant usage, état, entretien aux heures de fonctionnement et preuves d’étalonnage.",
},
facilities: {
name: "Bâtiments et installations",
description: "Bâtiments et leurs installations — maintenance planifiée, inspections de sécurité, locaux techniques et preuves réglementaires.",
},
},
newAvailable_many: "{{count}} nouvelles check-lists disponibles",
removedToast_many: "{{count}} check-lists retirées.",
keptNote_many: "{{count}} check-lists conservées car vous les avez modifiées.",
},
automationDescribe: {
chosenPerson: "la personne choisie",
chosenTeam: "l’équipe choisie",
chosenChecklist: "la liste de contrôle choisie",
chosenApprover: "l’approbateur choisi",
personAndTeam: "{{user}} et {{team}}",
theThreshold: "le seuil",
yourUrl: "votre URL",
severityUrgent: "un problème urgent",
severityAny: "n’importe quel problème",
templateClause: " réalisée avec « {{name}} »",
assignedClause: " attribuée à {{name}}",
notifyClause: " et préviendra {{who}}",
statusClause: " et passe au statut « {{status}} »",
failedFollowUp: "Lorsqu’une inspection{{template}} relève {{severity}}, AssetWRX créera une intervention de suivi{{assigned}}{{notify}}.",
renewalWork: "Lorsqu’un certificat ou un document atteint sa date de rappel, AssetWRX créera une intervention de renouvellement sur l’actif{{notify}}.",
highCostApproval: "Lorsqu’une intervention d’un montant de {{amount}} ou plus est créée, AssetWRX demandera à {{approver}} de la valider.",
unansweredChase_one: "Lorsqu’un prestataire n’a pas répondu à une invitation ou à une demande de devis depuis {{count}} jour, AssetWRX préviendra {{who}}, puis de nouveau chaque semaine jusqu’à ce qu’il réponde.",
unansweredChase_many: "Lorsqu’un prestataire n’a pas répondu à une invitation ou à une demande de devis depuis {{count}} de jours, AssetWRX préviendra {{who}}, puis de nouveau chaque semaine jusqu’à ce qu’il réponde.",
unansweredChase_other: "Lorsqu’un prestataire n’a pas répondu à une invitation ou à une demande de devis depuis {{count}} jours, AssetWRX préviendra {{who}}, puis de nouveau chaque semaine jusqu’à ce qu’il réponde.",
inspectionCompleted: "Lorsqu’une inspection est terminée, AssetWRX enverra ses détails à {{host}}.",
inspectionUpdated: "Lorsqu’une inspection est mise à jour{{status}}, AssetWRX enverra ses détails à {{host}}.",
jobCompleted: "Lorsqu’une intervention est terminée, AssetWRX enverra ses détails à {{host}}.",
jobStatusChanged: "Lorsqu’une intervention change de statut, AssetWRX enverra ses détails à {{host}}.",
assetCreated: "Lorsqu’un actif est créé, AssetWRX enverra ses détails à {{host}}.",
assetDeleted: "Lorsqu’un actif est supprimé, AssetWRX enverra ses détails à {{host}}.",
assetUpdated: "Lorsqu’un actif est mis à jour, AssetWRX enverra ses détails à {{host}}.",
webhookTick_one: "À intervalle de {{count}} minute, AssetWRX appellera {{host}}.",
webhookTick_many: "Toutes les {{count}} de minutes, AssetWRX appellera {{host}}.",
webhookTick_other: "Toutes les {{count}} minutes, AssetWRX appellera {{host}}.",
inboundForward: "Lorsque le webhook entrant de cette automatisation reçoit du JSON, AssetWRX le transmettra à {{host}}.",
inboundJobStatus: "Lorsque le webhook entrant de cette automatisation reçoit du JSON, AssetWRX s’en servira pour mettre à jour le statut de l’intervention indiquée.",
inboundCreateJob: "Lorsque le webhook entrant de cette automatisation reçoit du JSON, AssetWRX s’en servira pour créer une intervention.",
manualTest: "Lorsque vous la lancez manuellement, AssetWRX enverra un message de test à {{host}}.",
fallback: "Automatisation",
},
};
